import { MonthlyHoroscope, YearlyHoroscope } from './index';

// MESEČNI HOROSKOP - MAJ 2026
// Autor: Daniel Toma · Astro Aries Studio
// Planetarne pozicije verifikovane Swiss Ephemeris bazom podataka

export const MONTHLY_HOROSCOPES_APRIL_2026: MonthlyHoroscope[] = [
  {
    sign: 'Ovan',
    month: 'Maj',
    year: 2026,
    content: `**OVAN ♈ · 21. mart – 19. april · reč meseca: ISPIT**

**OPŠTI UVID**

Maj 2026. za Ovna nije lak mesec — ali je neophodan. Saturn na 9°–12° Ovna stoji tačno u tvom znaku i neće da se makne. To znači da svaki izbor, svaki zahtev koji postaviš svetu i sebi, svaka odgovornost koju si dosad gurao/la pred sobom — dolazi na naplatu. Nije ovo kazna. Ovo je Saturn koji gradi — ali gradi samo na mestima gde si kopao/la fundamente. Ako ih nema, posao je kopanje, ne gradnja.

Pored Saturna, i Neptun je na 3° Ovna — planeta magle, iluzija i duhovnosti. Ova kombinacija Saturn-Neptun u tvom znaku znači da nije uvek jasno šta je realno, a šta je ono čemu se nadaš. Proveravaj pre nego što veruješ. Naročito u prvoj polovini maja.

**LJUBAV I VEZE**

Pun Mesec 1. maja u Škorpiji pada u tvoje 8. polje — to je zona intimnosti, zajedničkih resursa, emotivnih dugova i transformacije. Ako postoji nerešeno pitanje u bliskom odnosu, ona se sada ne može zaobići. Partnerova finansijska situacija ili zajednički novac dolaze u fokus — ne iz dramatičnih razloga, nego zato što se ne može napredovati dok se to ne reši.

Venera je u Blizancima do 19. maja i aktivira tvoje 3. polje — komunikacija u vezama je lakša, šarmantnija i otvorenija nego inače. Iskoristi ovaj prozor za razgovore koje si odlagao/la. Od 19. maja Venera ulazi u Raka i prelazi u tvoje 4. polje — ljubav traži intimnost doma, bliskost porodice, emocionalno sidrenje. Romantika postaje nežnija i tiša.

**POSAO I NOVAC**

Mars je u Ovnu do 21. maja i aktivira tvoje 1. polje — imaš energiju, inicijativu i hrabrost za direktnu akciju. Razgovori o poslu, pregovori, nove inicijative — sve ovo ima snagu pre 21. maja. Merkur je u Ovnu do 5. maja — govori, potpisuj i donosi ključne odluke u prvim danima meseca, dok je komunikacija brza i jasna.

Od 21. maja Mars ulazi u Bika i prelazi u tvoje 2. polje — fokus se premešta sa akcije na resurse, novac i materijalna pitanja. Tempo pada, ali stabilnost raste. Mlad Mesec 16. maja u Biku direktno aktivira ovo polje — idealan datum za pokretanje finansijskog plana, otvaranje štednje ili konsolidaciju prihoda.

Saturn u tvom znaku u sekstilu sa Jupiterom u Raku znači da se tvrd rad u maju pretvara u konkretne temelje — ne u trenutnu nagradu, nego u strukturu koja traje.

**ZDRAVLJE I ENERGIJA**

Energetski nivo u prvoj polovini maja je visok zahvaljujući Marsu u Ovnu — ali je rasipanje te energije rizik. Ovan koji ne kanališe Mars kroz fokus — rasplinuje se i završava iscrpljen bez rezultata. Vežbanje, fizička aktivnost i redovan ritam su lek, ne opcija.

Neptun u tvom znaku unosi rizik od slabljenja granica — prema tuđim zahtevima, prema alkoholu ili supstancama, prema preuzimanju previše. Telo ti signalizira jasno; problem je kad se ti praviš da ne čuješ. Od 21. maja Mars prelazi u Bika — usporavanje je prirodno i treba ga prihvatiti kao odmor, a ne kao slabost.

**KLJUČNI DATUMI I TRANZITI**

✦ 1. maj — Pun Mesec u Škorpiji 11°: kulminacija u 8. polju — finansijski ili emotivni preokret
✦ 5. maj — Merkur ulazi u Bika: komunikacija usporava, pazi na pregovore
✦ 16. maj — Mlad Mesec u Biku 25°: novi finansijski ciklus, postavi namere oko novca
✦ 19. maj — Venera ulazi u Rak: toplina u domu i porodici
✦ 21. maj — Mars ulazi u Bika: energija se premešta na materijalno polje`,
  },
  {
    sign: 'Bik',
    month: 'Maj',
    year: 2026,
    content: `**BIK ♉ · 20. april – 20. maj · reč meseca: SLOBODA**

**OPŠTI UVID**

Sedam godina Urana u Biku. Sedam godina nepredvidivih promena, rušenja sigurnosti, reinvencija koje nisi tražio/la. Sve je počelo 2018. — karijerne promene, finansijska nestabilnost, telo koje se menjalo, identitet koji se prepisivao. I onda, 27. aprila 2026. — Uran napušta Bika i ulazi u Blizance. Maj 2026. je prva stranica novog poglavlja, i osetiš to — u kostima, u ritmu disanja, u tome kako se jutro oseća.

Sunce je u Biku do 20. maja — tvoja godišnja sezona energije, vidljivosti i obnove. Mlad Mesec 16. maja pada na 25° Bika — direktno u tvoj znak. Ovo je jedan od najmoćnijih Mladih Meseca za Bika u ovom ciklusu. Što posadeš kao nameru na ovaj datum, raste cele naredne godine.

**LJUBAV I VEZE**

Pun Mesec 1. maja u Škorpiji aktivira tvoje 7. polje — partnerstvo, bliski odnosi, i ono što je do sada ostajalo neizrečeno u vezama. Za Bikove u vezama: nešto dolazi na videlo ili se donosi odluka koja je dugo čekala. Za slobodne: osoba ili situacija koja podstiče duboko preispitivanje toga šta tražiš.

Venera, tvoj vladar, ulazi u Raka 19. maja i prelazi u tvoje 3. polje — ljubav se izražava kroz reči, poruke, blizinu, svakodnevni kontakt. Kratke poruke, pažljivi razgovori, prisustvo u malim trenucima. Od 19. maja intimnost dobija toplinu Raka — zahteva više emocionalne nežnosti i odgovara na nju.

**POSAO I NOVAC**

Merkur ulazi u Bika 5. maja i ostaje do 22. maja — ovo je tvoj prirodni ritam razmišljanja i komunikacije: temeljno, precizno, sporo ali sigurno. Pregovaraj u maju. Potpisuj ugovore. Donosi finansijske odluke koje zahtevaju preciznost i analizu. Saturn u Ovnu (tvoje 12. polje) upozorava da postoji skrivena cena — nešto što nisi uzeo/la u obzir ili dugovanje koje se ne vidi jasno. Proveri pre nego što zatvoriš dogovor.

Uran je sada u Blizancima — tvoje 2. polje novca i vrednosti. Ovo je početak 7-godišnjeg ciklusa transformacije tvog finansijskog polja. Ne dramatično odmah, ali maj uvodi prve naznake: drugačiji prihodi, nova vrednovanja, neočekivana finansijska promena. Obraćaj pažnju šta se menja u toj sferi tokom maja — to je signal trenda koji će trajati.

**ZDRAVLJE I ENERGIJA**

Pun Mesec 1. maja u Škorpiji može doneti emotivnu iscrpljenost — Bik koji drži teret unutra bez ventila. Telo Bika u maju traži senzorni komfor: dobar san, ukusna hrana, fizički kontakt, priroda. Nije to slabost — to je tvoj način punjenja baterija.

Mars ulazi u Bika 21. maja — od tog datuma imaš direktnu energiju za fizičku aktivnost i akciju. Može doći i do napetosti u vratu i ramenima (Bikov deo tela) — radi na opuštanju i pokretljivosti.

**KLJUČNI DATUMI I TRANZITI**

✦ 1. maj — Pun Mesec u Škorpiji: kulminacija u 7. polju — partnerski preokret
✦ 5. maj — Merkur ulazi u Bika: tvoja sezona precizne komunikacije počinje
✦ 16. maj — MLAD MESEC u Biku 25°: najvažniji datum meseca — postavi namere!
✦ 19. maj — Venera ulazi u Rak: ljubav kroz bliskost i negu
✦ 20. maj — Sunce ulazi u Blizance: tvoja sezona se završava, novi ciklus počinje
✦ 21. maj — Mars ulazi u Bika: energija i inicijativa direktno u tvom znaku`,
  },
  {
    sign: 'Blizanci',
    month: 'Maj',
    year: 2026,
    content: `**BLIZANCI ♊ · 21. maj – 20. jun · reč meseca: REVOLUCIJA**

**OPŠTI UVID**

Nešto se probudilo. Uran je 27. aprila ušao u Blizance — prvi put u 84 godine. Ovo nije metafora niti poetska slika. Ovo je planetarna realnost: planeta iznenadnih promena, proboja, tehničkih revolucija i oslobođenja ušla je u tvoj znak. Ako su poslednje godine donele osećaj stagnacije, repetitivnosti, zaostalih priča — maj 2026. je tačka raskida. Ne sa dramatičnom scenom, nego sa jednom idejom, jednim razgovorom, jednom odlukom koja menja pravac.

Sunce ulazi u Blizance 20. maja, Merkur (tvoj vladar) ulazi u tvoj znak 22. maja — i u tih poslednjih 10 dana meseca sve se ubrzava. Ideje koje dolaze u tom periodu nisu slučajne. Zapisuj ih. Razgovori koji se vode nisu mali. Veze koje se uspostavljaju nose seme nečega što traje.

**LJUBAV I VEZE**

Venera je u Blizancima ceo prvi deo maja, do 19. — šarm, komunikacija, intelektualna privlačnost. Lakše je biti zabavan/a, spontan/a, otvoren/a prema novim kontaktima. Blizanci u vezama: osvežavajuće razgovore, nova iskustva koja deli sa partnerom, lakšu atmosferu. Slobodni Blizanci: privlačnost dolazi kroz reč, humor i intelektualnu vezu.

Od 19. maja Venera ulazi u Raka i prelazi u tvoje 2. polje — ljubav dobija finansijsku i vrednosnu dimenziju. Šta vreduješ u odnosu? Šta si spreman/a da uložiš? Ko odgovara na tvoje osnovne potrebe za sigurnošću? Ova pitanja nemaju brzih odgovora, ali počinju da se postavljaju.

Pun Mesec 1. maja u Škorpiji aktivira tvoje 6. polje — emotivne napetosti mogu doći kroz radno okruženje ili zdravstvenu rutinu.

**POSAO I NOVAC**

Jupiter u Raku (tvoje 2. polje) ceo maj donosi finansijsku ekspanziju — ali kroz emocionalno poverenje, ne kroz hladnu kalkulaciju. Poveruj u projekte koji te istinski raduju. Novac ide tamo gde ideš ti. Ovo zvuči idealistički, ali Jupiter u 2. polju to potvrđuje numerički: prihodi rastu tamo gde je autentičnost.

Merkur, tvoj vladar, ulazi u Blizance 22. maja. Od tog datuma misliš brže, komuniciraš jasnije, i vidiš veze koje su drugima nevidljive. Korist: mentalna oštrina i pregovaračka snaga. Rizik: prihvatanje previše projekata odjednom.

Uran u tvom znaku u 1. polju znači da će neke profesionalne prilike doći iznenada — poziv koji nisi očekivao/la, ponuda koja ne stoji čekati. Budi spreman/a da reaguješ brzo.

**ZDRAVLJE I ENERGIJA**

Nervni sistem je pod povećanim opterećenjem — Uran i Merkur zajedno u Blizancima ubrzavaju protok informacija do tačke preopterećenja. Maj zahteva svesne pauze od ekrana, od buke, od stalnog inputa. Vežbe disanja, šetnje bez slušalica, spavanje bez telefona — ovo nije luksuz, ovo je mentalna higijena.

Pun Mesec 1. maja u Škorpiji može doneti somatske simptome stresa — problemi sa varenjem, napetost u rukama ili ramenima (Blizančev deo tela). Telo govori što um prećutkuje.

**KLJUČNI DATUMI I TRANZITI**

✦ 1. maj — Pun Mesec u Škorpiji: kulminacija u 6. polju — zdravlje ili posao
✦ 19. maj — Venera ulazi u Rak: vrednosna dimenzija u ljubavi dolazi u fokus
✦ 20. maj — Sunce ulazi u Blizance: tvoja sezona energije počinje
✦ 22. maj — Merkur ulazi u Blizance: mentalna oštrina na vrhuncu
✦ 22. maj — Uran + Merkur: mentalni breakthrough, ključne ideje, ne ignorisati`,
  },
  {
    sign: 'Rak',
    month: 'Maj',
    year: 2026,
    content: `**RAK ♋ · 21. jun – 22. jul · reč meseca: RAST**

**OPŠTI UVID**

Jupiter je na 18°–23° u Raku tokom celog maja 2026. — i to nije simboličan detalj u tekstu. To je planetarni gigant koji širi sve što dotakne, a ceo maj boravi u tvom znaku. Rast koji Rak oseća u ovom periodu nije površan. Nije samo "dobro osećanje". To je fundamentalna ekspanzija unutrašnje sigurnosti, porodičnih veza, sposobnosti da negoješ i budeš negovan/a — i to na načine koji ostavljaju trag.

Uz Jupitera, i Venera ulazi u Raka 19. maja — i od tog trenutka tvojih poslednjih 12 dana maja donosi jednu od najtoplijih ljubavnih energija u tvojoj godini. Prihodi mogu biti veći, privlačnost pojačana, emocionalne veze dublje. Platforma za ono što dolazi u junu — tvojoj sezoni — gradi se upravo sada.

**LJUBAV I VEZE**

Pun Mesec 1. maja u Škorpiji pada u tvoje 5. polje — kreativnost, romantika, zadovoljstvo i (za roditelje) deca. Nešto što si gajio/la u srcu — osećaj, veza, kreativni projekat — dolazi u svetlost. Za neke Rakove ovo može biti emotivna kulminacija u ljubavnoj priči. Za druge: oslobađanje kreativne blokade koja je trajala mesecima.

Venera ulazi u Rak 19. maja i ostaje do sredine juna — ovo je tvoja Venera. Osetiš kada Venera uđe u tvoj znak: lakše privlačiš, osećaš se lepše u sopstvenoj koži, odnosi imaju više topline. Ako si u vezi — maj je mesec za produbljivanje, ne za probleme. Ako si slobodan/a — intenzitet privlačnosti od 19. maja je realan signal, ne iluzija.

**POSAO I NOVAC**

Saturn u Ovnu (tvoje 10. polje) u tenziji sa Jupiterom u tvom znaku znači da pored blagostanja i rasta, postoji profesionalni zahtev koji se ne može ignorisati. Karijera u maju traži odgovornost i strukturu. Jupiter ti daje resurse i samopouzdanje — Saturn traži da ih usmeriš konkretno, ne raseješ.

Sunce je u Biku do 20. maja i aktivira tvoje 11. polje — socijalna mreža, kolektivni projekti, prilike koje dolaze kroz zajednicu i kontakte. Ovo nije mesec za solo rad. Umreži se, pojavi se, prihvati pozive.

Mlad Mesec 16. maja u Biku aktivira tvoje 11. polje — idealan datum za pokretanje grupnog projekta, pridruživanje organizaciji ili traženje saradnika.

**ZDRAVLJE I ENERGIJA**

Jupiter u tvom znaku može doneti sklonost ka preterivanju — u hrani, u emocijama, u obavezama. Rak koji ne zna da kaže "ne" ostaje prazan dok puni sve oko sebe. Maj je mesec da svesno praviš granice — ne iz hladnoće, nego iz samozaštite.

Emotivni kapacitet Raka je u maju izuzetno visok — ali i osetljivost na tuđe energije. Biraj kome daješ vreme. Meditacija, voda, mirno jutro — sve to pomaže da ostaneš centriran/a.

**KLJUČNI DATUMI I TRANZITI**

✦ 1. maj — Pun Mesec u Škorpiji: kulminacija u 5. polju — ljubav, kreativnost, radost
✦ 16. maj — Mlad Mesec u Biku: novi ciklus u 11. polju — saradnja i mreža
✦ 19. maj — Venera ulazi u RAK: tvoja ljubavna sezona počinje
✦ 20. maj — Sunce→Blizanci: kolektivna aktivnost opada, pokreće se priprema za tvoju sezonu`,
  },
  {
    sign: 'Lav',
    month: 'Maj',
    year: 2026,
    content: `**LAV ♌ · 23. jul – 22. avgust · reč meseca: POZICIJA**

**OPŠTI UVID**

Pluto je u Vodoliji — direktno nasuprot Lavu. Ovo je dugotrajan tranzit (do 2043.) koji polako i nemilosrdno transformiše sve tvoje bliže odnose: partnerstvo, važne saradnike, ljude koji stoje kao ogledalo tvojih odluka. Maj 2026. nije dramatičan korak u ovom procesu, ali je mesec u kome se jasno vidi ko je zaista uz tebe, a ko je bio tu dok je lako. Pluto ne laže.

Sunce u Biku do 20. maja aktivira tvoje 10. polje — karijera, javna slika, autoritet, vidljivost. Lav koji ostaje u pozadini u maju — gubi prilike. Pojavljuj se, izlažeš se, zauzimaj mesto za stolom.

**LJUBAV I VEZE**

Pun Mesec 1. maja u Škorpiji pada u tvoje 4. polje — dom, porodica, unutrašnja baza. Napetost između karijernih ambicija i privatnog mira dolazi na površinu. Ako si zanemarivao/la emotivne potrebe (svoje ili partnerove) u ime posla — Pun Mesec to donosi kao račun.

Venera u Blizancima do 19. maja aktivira tvoje 11. polje — ljubavni kontakti mogu doći kroz socijalna okruženja, grupe, događaje. Slobodni Lavovi: maj je dobar za upoznavanje novih ljudi, naročito u prvoj polovini. Vezani Lavovi: zajednički socijalni život jača vezu.

Od 19. maja Venera ulazi u Raka (12. polje) — ljubav postaje tiša, privatnija, manje javna. Period za emotivno procesiranje, ne za nova poznanstva.

**POSAO I NOVAC**

Mlad Mesec 16. maja u Biku pada u tvoje 10. polje — ovo je jedan od najvažnijih karijernih Mladih Meseca ove godine za Lava. Postavi namere oko profesionalnog napretka: promocija, novi projekat, promena pozicije, pokretanje sopstvenog. Što god zasejеš 16. maja u karijeri — raste do kraja 2026.

Mars u Ovnu do 21. maja aktivira tvoje 9. polje — višestruki frontovi u poslu, ambiciozni planovi, mogućnosti iz inostranstva ili iz oblasti obrazovanja i medija. Brz, direktan nastup. Od 21. maja Mars ulazi u Bika (10. polje) — dugotrajan, strpljiv rad koji gradi rezultate solidno.

**ZDRAVLJE I ENERGIJA**

Jupiter u Raku aktivira tvoje 12. polje — skrivena energija, unutrašnji procesi, odmor koji se plaća. Lavovi koji ignorišu potrebu za povlačenjem i odmorom u maju — plaćaju energetsku cenu u junu. Uvedi barem jednu jutarnju rutinu koja ne uključuje ekran ili socijalni performance. Kreativna ekspresija (muzika, pisanje, umetnost) je jak lek ovog meseca.

**KLJUČNI DATUMI I TRANZITI**

✦ 1. maj — Pun Mesec u Škorpiji: dom vs. karijera — nešto se balansira
✦ 16. maj — MLAD MESEC u Biku: karijernih namere — ključni datum!
✦ 19. maj — Venera→Rak: ljubav postaje privatnija i intimnija
✦ 21. maj — Mars→Bik: karijernam fokus jača i usporava na pravu meru`,
  },
  {
    sign: 'Devica',
    month: 'Maj',
    year: 2026,
    content: `**DEVICA ♍ · 23. avgust – 22. septembar · reč meseca: MREŽA**

**OPŠTI UVID**

Jupiter u Raku u tvojoj 11. kući — ovo je planetarni blagoslov koji greje prostor kolektiva, prijatelja, mreže i zajedničkih nada. Devica u maju nije pozvana da radi sama u precizno sređenom kutku. Pozvana je da izađe, poveže se, iskoristi socijalni kapital koji je gradila tiho, bez fanfara, godinama. Maj je mesec u kome se to vraća.

Merkur, tvoj vladar, je u Biku do 22. maja — tvoj prirodni saveznik za analitično i temeljno razmišljanje. Potpisuj ugovore, završavaj pregovore, revidiraj projekte. Od 22. maja Merkur ulazi u Blizance i menja ritam — brže, površinije, više frontova odjednom. Pripremi se da pratiš.

**LJUBAV I VEZE**

Pun Mesec 1. maja u Škorpiji aktivira tvoje 3. polje — komunikacija u vezama dolazi na test. Ono što je ostalo neizrečeno između tebe i partnera sada čeka izgovoreni oblik. Za slobodne Device: važan razgovor, poruka ili kontakt koji remeti rutinu.

Venera u Blizancima do 19. maja aktivira tvoje 10. polje — privlačnost dolazi kroz profesionalizam, stručnost i kompetenciju. Nije romantično, ali je efikasno: upoznaješ ljude kroz posao ili javni nastup. Od 19. maja Venera ulazi u Raka (11. polje) — romantika kroz grupu, zajedničke aktivnosti, prijatelje koji uvode partnera.

**POSAO I NOVAC**

Uran ulazi u Blizance i aktivira tvoje 10. polje karijere — ovo je početak 7-godišnje revolucije u tvom profesionalnom identitetu. Maj daje prve naznake: nešto se menja u strukturi posla, u tome kako si percipiran/a, u vrsti posla koji te privlači. Ne boj se nepoznatog u karijernom smislu — Uran donosi oslobođenje, ne haos.

Saturn u Ovnu aktivira tvoje 8. polje — zajedničke finansije, poreske obaveze, dugovi, ortakluk. Nešto finansijsko traži konačnu odluku. Mlad Mesec 16. maja u Biku (9. polje) je idealan za ugovaranje edukacije, međunarodnih projekata ili pravnih pitanja.

**ZDRAVLJE I ENERGIJA**

Devica koja je pod Merkurovim tempom u Biku do 22. maja — temeljno procesira, temeljno brine o sebi. Usvajanje zdravstvene rutine, pregled koji si odlagao/la, promena ishrane — sve ovo ima podršku do 22. maja. Od 22. maja Merkur ubrzava i zdravstvena disciplina može da se razlabavi. Zadrži navike koje si izgradio/la.

**KLJUČNI DATUMI I TRANZITI**

✦ 1. maj — Pun Mesec u Škorpiji: komunikacijski preokret u 3. polju
✦ 16. maj — Mlad Mesec u Biku: namere oko obrazovanja i pravnih pitanja
✦ 19. maj — Venera→Rak: ljubavni kontakti kroz grupu i prijatelje
✦ 22. maj — Merkur→Blizanci: karijerni fokus se ubrzava i proširuje`,
  },
  {
    sign: 'Vaga',
    month: 'Maj',
    year: 2026,
    content: `**VAGA ♎ · 23. septembar – 22. oktobar · reč meseca: ODNOSI**

**OPŠTI UVID**

Saturn u Ovnu direktno se nalazi u tvojoj 7. kući — kući partnerstva, bliskih odnosa i svega što radiš zajedno sa drugima. Za Vage rodjene od 1. do 15. oktobra: Saturn je sada u direktnoj opoziciji sa tvojim Suncem. Ovo je jedan od najtežih, ali i najformativnijih tranzita u odraslom životu — pojavljuje se otprilike jednom u 30 godina. Pitanje koje Saturn postavlja nije "da li si srećan/a u ovom odnosu?" — nego "ko stvarno stoji pored tebe, i šta to košta?"

Vaga koja pokušava da se izvuče sa privremenom harmonijom u maju — pravi sebi dug koji kasni plaća. Autentičnost u vezama, jasne granice, hrabro postavljanje pitanja koja bole — to je Saturnovа agenda. I ima smisla.

**LJUBAV I VEZE**

Jupiter u Raku aktivira tvoje 10. polje kroz ugao karijere — ali u ljubavnom kontekstu, ovo znači da su tvoje profesionalne ambicije pod povećanjem partnera ili potencijalnog partnera. Vas dvoje imate različite načine razumevanja uspeha i ugleda? Maj to testira.

Pun Mesec 1. maja u Škorpiji u tvom 2. polju — finansijska realnost u vezama dolazi na videlo. Ko šta plaća, ko vreduje šta, ekonomska neravnoteža koja je možda do sada bila ignorisana — sve to sada ima glas.

Venera, tvoj vladar, je u Blizancima do 19. maja — komunikacija u ljubavi je lakša, šarmantnija, otvorenija. Iskoristi ovaj prozor za iskrene razgovore pre nego što Venera uđe u Raka 19. maja i emocije postanu teže za verbalizovati.

**POSAO I NOVAC**

Pluto u Vodoliji u tvom 5. polju formira trin sa tvojim znakom — transformativna kreativna moć, sposobnost da promeniš nešto iz korena u polju kreativnosti, romantike ili projekata koje vodiš solo. Ovo je tiha, ali snažna podrška za projekte koji zahtevaju hrabrost i originalnost.

Mlad Mesec 16. maja u Biku aktivira tvoje 8. polje — zajednički resursi, ortakluk, transformacija vrednosti. Ako postoji finansijska odluka sa partnerom ili saradnikom — ovaj datum je pravo vreme za resetovanje.

**ZDRAVLJE I ENERGIJA**

Saturn u opoziciji može doneti fizičku iscrpljenost naročito u donjem delu leđa i bubrezima (Vagini delovi tela). Dovoljan san, hidracija i rasterećivanje emocionalnog tereta kroz razgovor ili pisanje — ključni su. Vaga koja drži sve unutra ima viši rizik od somatizacije.

**KLJUČNI DATUMI I TRANZITI**

✦ 1. maj — Pun Mesec u Škorpiji: finansijska realnost u 2. polju
✦ 16. maj — Mlad Mesec u Biku: reset u 8. polju — zajednički resursi
✦ 19. maj — Venera→Rak: emocije u vezama postaju dublje i teže za rečima
✦ 21. maj — Mars→Bik: dinamika partnerstva se intenzivira`,
  },
  {
    sign: 'Škorpija',
    month: 'Maj',
    year: 2026,
    content: `**ŠKORPIJA ♏ · 23. oktobar – 21. novembar · reč meseca: KULMINACIJA**

**OPŠTI UVID**

Pun Mesec 1. maja pada na 11° Škorpije — u tvoj znak, u tvoje 1. polje. Ovo je personalna kulminacija: nešto što si nosio/la — osećaj, situacija, istina, teret — dolazi u svetlost i traži da bude priznat/o. Škorpija poznaje ovu dinamiku bolje od bilo kog znaka. Zna da se razotkrivanje ne bira po vremenu, ali zna i da ono što se ne reši samo nalazi izlaz — kroz telo, kroz snove, kroz sukob.

Jupiter u Raku formira savršen trin sa tvojim znakom iz 9. polja — ekspanzija znanja, vera, duhovni rast, daleki kontakti, pravne prilike. Maj je mesec u kome duboka Škorpijina intuicija dobija i intelektualnu i duhovnu potvrdu.

**LJUBAV I VEZE**

Mlad Mesec 16. maja u Biku pada u tvoje 7. polje — novo partnersko poglavlje. Za one u vezama: resetuje se dinamika, razgovor koji je bio nemoguć sada postaje moguć. Za slobodne: novi kontakt koji dolazi u ovom periodu nosi potencijal za ozbiljnu vezu — nije to svakodnevni flert.

Mars u Ovnu do 21. maja aktivira tvoje 6. polje — energija u svakodnevnom životu i poslu je visoka, ali pazi na impulzivnost u emotivnim situacijama na radnom mestu. Od 21. maja Mars ulazi u Bika i aktivira 7. polje — dinamika u partnerskim odnosima postaje intenzivnija i zahteva više pažnje.

Venera ulazi u Raka 19. maja i aktivira tvoje 9. polje — romantika kroz zajednička putovanja, učenje, ekspanziju. Privlačnost dobija filozofsku dimenziju.

**POSAO I NOVAC**

Jupiter u 9. polju ceo maj — prilike koje dolaze sa strane, iz inostranstva, iz oblasti obrazovanja, medija ili prava. Ako postoji mogućnost saradnje sa nekim ko je van tvoje uobičajene mreže — ne odbijaj odmah.

Uran je sada u Blizancima, u tvom 8. polju — transformacija resursa, finansijska iznenađenja (pozitivna ili negativna), promene u zajedničkim finansijama. Bukvalno: neko ti može preneti resurs koji nisi očekivao/la, ili se menja finansijska struktura sa partnerom/ortakom. Prati novac u maju.

**ZDRAVLJE I ENERGIJA**

Pun Mesec u tvom znaku može doneti emotivno pražnjenje — nije loše, nego neophodno. Škorpija koja ne plače, ne priča, ne ispušta — akumulira dok ne eksplodira. Maj nudi kontrolisano ispuštanje tenzije. Prihvati to. Voda u svim oblicima leči Škorpiju: kupanje, plivanje, dosta tečnosti, boravak uz more ili reku ako je moguće.

**KLJUČNI DATUMI I TRANZITI**

✦ 1. maj — PUN MESEC u ŠKORPIJI: tvoj mesec — kulminacija, razotkrivanje, završetak
✦ 16. maj — Mlad Mesec u Biku: novo partnersko poglavlje
✦ 19. maj — Venera→Rak: romantika dobija dubinu i prostranstvo
✦ 21. maj — Mars→Bik: partnerska dinamika jača`,
  },
  {
    sign: 'Strelac',
    month: 'Maj',
    year: 2026,
    content: `**STRELAC ♐ · 22. novembar – 21. decembar · reč meseca: DUBINA**

**OPŠTI UVID**

Jupiter, tvoj vladar, je u Raku na 18°–23° — u tvojoj 8. kući. 8. kuća nije komforan teritorij za Strelca koji voli slobodu, lakoću i horizontale. 8. kuća je zona transformacije, zajedničkih resursa, intimnih dugova, emocionalnih poravnanja, nasleđa i svega što dolazi od i kroz druge. Maj 2026. traži od tebe da ideš dublje nego što ti je prirodno — i da prihvatiš da neka vredna iskustva ne dolaze kroz širi horizont, nego kroz intimniji, tamniji prostor.

Pun Mesec 1. maja u Škorpiji aktivira tvoje 12. polje — skriveno, nesvesno, sve ono što je iza scene tvog svesnog života. Nešto se procesira bez tvoje kontrole. Neka to bude.

**LJUBAV I VEZE**

Uran u Blizancima aktivira tvoje 7. polje — ovo je početak 7-godišnje periode transformacije tvojih partnerskih odnosa. U maju su to tek prvi signali: nešto se menja u tome kako doživljavaš partnera ili kako prilaziš vezama uopšte. Sloboda unutar veze postaje važnija nego ikad — ali i autentičnost partnera.

Venera u Blizancima do 19. maja aktivira tvoje 7. polje — privlačnost je intelektualna, verbalna, razigrana. Partner koji te stimuliše mentalno privlači više od onoga koji te samo emotivno podržava. Od 19. maja Venera ulazi u Raka i aktivira 8. polje — intimnost postaje dublja i kompleksnija.

**POSAO I NOVAC**

Saturn u Ovnu (5. polje) + Jupiter u Raku (8. polje) — kombinacija koja zahteva kreativan rad sa trajnim rezultatima. Strelac koji radi nešto što ga ne inspiruje u maju oseti to teže nego inače. Energija je tu za projekte koji nose viziju — ne za rutinu.

Mlad Mesec 16. maja u Biku (6. polje) — idealan datum za uspostavljanje zdravstvene i radne rutine. Menjaj navike: rano ustajanje, fizička aktivnost, bolji raspored. Ove male promene imaju veliki kumulativan efekat.

**ZDRAVLJE I ENERGIJA**

Butovi i kičma su Strelčev deo tela — i maja su pod pojačanom pažnjom. Sedenje bez pokreta je problem. Strelcu treba kretanje, prostor, vazduh. Planinska šetnja, vožnja bicikla, trčanje — sve što daje osećaj slobode i prostor za misao u pokretu. Pun Mesec u 12. polju može doneti neobjašnjivu iscrpljenost — to je poziv na odmor, ne na zabrinutost.

**KLJUČNI DATUMI I TRANZITI**

✦ 1. maj — Pun Mesec u Škorpiji: procesiranje u 12. polju — odmor i povlačenje
✦ 16. maj — Mlad Mesec u Biku: zdravstvene navike — postavi novi ritam
✦ 19. maj — Venera→Rak: intimnost u vezama dobija dubinu
✦ 21. maj — Mars→Bik: energija za zdravlje i posao se stabilizuje`,
  },
  {
    sign: 'Jarac',
    month: 'Maj',
    year: 2026,
    content: `**JARAC ♑ · 22. decembar – 19. januar · reč meseca: RAVNOTEŽA**

**OPŠTI UVID**

Jupiter u Raku direktno se suprotstavlja Jarcu iz 7. polja — ovo je Jupiterov impuls koji dolazi kroz druge ljude: partneri, saradnici, klijenti, bliski odnosi nose prilike, ali i zahtevaju od tebe da daješ onoliko koliko primaš. Jarac koji se zatvori u soliternu ambicioznost u maju — propušta ono što Jupiter nudi. A nudi dosta: poverenje, širenje kroz odnose, prilike koje dolaze "odozgo" kroz lične preporuke.

Saturn, tvoj vladar, je u Ovnu na 9°–12° — u tvojoj 4. kući. Dom, porodica, poreklo, stambena pitanja. Jarčevi koji su godinama odlagali rešenje porodičnog ili stambenog problema sada ne mogu više da ga guraju ispred sebe. Saturn to zahteva. Ne kao kazna — nego kao osnova bez koje ni ambicija nema gde da stoji.

**LJUBAV I VEZE**

Pun Mesec 1. maja u Škorpiji aktivira tvoje 11. polje — kulminacija u grupi, prijatelji, kolektivne veze. Neko od tvojih bliskih kontakata dolazi na naplatu — neko ko je uvek bio tu, ali nisi adresirao/la tu zahvalnost. Ili: u tvojoj mreži dolazi do promene koja menja i tvoj emocionalni pejzaž.

Venera u Blizancima do 19. maja aktivira tvoje 6. polje — ljubav se izražava kroz pomaganje, praktičnost, zajedničku rutinu. Partnera se ceni kroz dela, a ne reči. Od 19. maja Venera ulazi u Raka i aktivira 7. polje — direktna toplina i nega u partnerskim odnosima.

**POSAO I NOVAC**

Mlad Mesec 16. maja u Biku (5. polje) — kreativnost, autorski projekti, projekti koji nose tvoj lični pečat. Pokreni nešto što je tvoje, ne samo nešto što radi za druge. Uran u Blizancima aktivira tvoje 6. polje — revolucija u svakodnevnom radu, promene radnog mesta, novih alata i metodologija. Maj može doneti neočekivane promene u strukturi posla — fleksibilnost je prednost.

Jupiter u opoziciji može doneti prilike kroz joint venture ili saradnju. Postoji partner (poslovni ili lični) koji otvara vrata koja sam ne bi mogao/la.

**ZDRAVLJE I ENERGIJA**

Zglobovi i kosti su Jarčev deo tela — i Saturn u kvadratu može pojačati napetost u ovim oblastima. Redovna fizička aktivnost koja jača kosti i zglobove: hodanje, plivanje, joga. Saturn u 4. kući može doneti i stres vezan za dom ili porodicu koji se somatizuje. Nauči da razdvojiš profesionalni i privatni prostor — energetski, ne samo fizički.

**KLJUČNI DATUMI I TRANZITI**

✦ 1. maj — Pun Mesec u Škorpiji: kulminacija u 11. polju — ko su tvoji pravi saveznici
✦ 16. maj — Mlad Mesec u Biku: kreativni početak u 5. polju — pokreni sopstveni projekat
✦ 19. maj — Venera→Rak: toplina direktno u 7. polju — partnerstvo cveta
✦ 21. maj — Mars→Bik: kreativna i romantična energija jača`,
  },
  {
    sign: 'Vodolija',
    month: 'Maj',
    year: 2026,
    content: `**VODOLIJA ♒ · 20. januar – 18. februar · reč meseca: PROBOJ**

**OPŠTI UVID**

Uran u Blizancima formira savršen vazdušni trin sa Vodolijom — i ovo je jedna od retkih konstelacija koje donose pravo, organsko olakšanje Vodoliji posle dugo vremena. Pluto u tvom znaku radi dubok, spor posao transformacije identiteta — ali Uran u trinu sada ubrzava onaj deo procesa koji je bio blokiran. Proboji u maju dolaze kao ideje koje se pojavljuju odjednom, kao razgovori koji otvaraju perspektivu, kao susreti koji izgledaju slučajni, a nisu.

Pun Mesec 1. maja u Škorpiji aktivira tvoje 10. polje — profesionalna kulminacija, javna vidljivost, prepoznatost. Nešto što si radio/la u tišini sada dobija svoju scenu.

**LJUBAV I VEZE**

Uran u Blizancima aktivira tvoje 5. polje — kreativnost, romantika, iznenada spontana atrakcija. Vodolija u ljubavi dobija podstrek od Urana kroz neočekivane susrete, netipične veze, slobodu u romansi. Ovo nije vreme za konvencionalne pristupe ljubavi — autentičnost privlači.

Venera je u Blizancima do 19. maja i direktno aktivira 5. polje — ljubav i zabava se prepliću. Socijalni događaji, zajednička iskustva, intelektualna stimulacija u romantičnom kontekstu. Od 19. maja Venera ulazi u Raka i aktivira 6. polje — ljubav se izražava kroz brigu, praktičnu podršku i svakodnevno prisustvo.

**POSAO I NOVAC**

Saturn u Ovnu (3. polje) u sekstilu sa Vodolijom — strukturisana komunikacija, ozbiljan pristup pisanju, prezentacijama i ugovaranju. Što komuniciraš u maju ima težinu — koristi to strateški.

Mlad Mesec 16. maja u Biku aktivira tvoje 4. polje — stambene promene, rad od kuće, porodični poslovni projekti. Ako radiš od kuće ili imaš porodični posao — maj je period za sređivanje tih temelja.

Pun Mesec 1. maja u tvom 10. polju je karijerni magnet — čak i ako se ne trudiš, bićeš primećen/a. Pripremi se da budeš spreman/a za prilike koje dolaze odozgo.

**ZDRAVLJE I ENERGIJA**

Vodolija može imati problema sa cirkulacijom i nervnim sistemom — i Uran/Merkur tranziti u vazdušnom trouglu to pojačavaju. Vežbe koje aktiviraju cirkulaciju i smiruju nervni sistem: plivanje, joga, meditacija u pokretu. Izlazak u prirodu je lek koji Vodolija zaboravlja da uzima.

**KLJUČNI DATUMI I TRANZITI**

✦ 1. maj — PUN MESEC u Škorpiji: karijerni proboj u 10. polju — budi spreman/a
✦ 16. maj — Mlad Mesec u Biku: stambene i porodične namere
✦ 19. maj — Venera→Rak: ljubav se izražava kroz svakodnevnu brigu
✦ 22. maj — Merkur+Uran TRIN: mentalni breakthrough — ključne ideje, ne ignorisati`,
  },
  {
    sign: 'Ribe',
    month: 'Maj',
    year: 2026,
    content: `**RIBE ♓ · 19. februar – 20. mart · reč meseca: TEMELJI**

**OPŠTI UVID**

Saturn i Neptun su oba u Ovnu — u tvojoj 2. kući. Ovo je snažna i kompleksna konstelacija: Saturn zahteva finansijsku odgovornost, konkretnost, budžet, plan. Neptun unosi duhovnu dimenziju vrednosti — pitanje nije samo "koliko imaš" nego "šta vreduješ". Maj 2026. za Ribe je mesec u kome se ove dve dimenzije moraju pomiriti. Ribe koje potroše maj sanjajući o idealnoj finansijskoj situaciji bez konkretnih koraka — u junu se suočavaju sa istim problemom uvećanim.

Jupiter u Raku aktivira tvoje 5. polje ceo maj — kreativnost, ljubav, radost, deca. Ovo je blag, topao protivtok koji balansira Saturnov pritisak. Ribe imaju visok kreativni kapacitet u maju. Koristite ga.

**LJUBAV I VEZE**

Pun Mesec 1. maja u Škorpiji pada u tvoje 9. polje — duhovna i filozofska kulminacija u ljubavi. Nešto u tvojoj slici sveta o vezama ili partneru se kristalizuje. Za neke Ribe: dugo putovanje ili susret sa nekim iz dalekog kraja koji menja perspektivu. Za druge: uviđanje da odnos koji imaš ili tražiš mora imati dublje zajedničke vrednosti.

Venera ulazi u Raka 19. maja i aktivira tvoje 5. polje — ljubav i radost se prepliću. Kreativni izlasci, romantični gestovi, spontana igra. Ribe koje su se u zadnje vreme osećale ozbiljno i teško — od 19. maja dišu lakše u ljubavnoj sferi.

**POSAO I NOVAC**

Mlad Mesec 16. maja u Biku aktivira tvoje 3. polje — komunikacija, kratki projekti, pisanje, lokalni kontakti. Pokreni blog, pokreni newsletter, kontaktiraj ljude koje si dugo planirao/la. Male akcije u komunikaciji imaju veliki povrat u ovom mladu.

Uran u Blizancima aktivira tvoje 4. polje — promena mesta stanovanja, rad od kuće, promena baze. Neke Ribe će u ovom 7-godišnjem ciklusu promeniti grad ili način življanja koji smatraju "domom". Maj daje prve naznake.

**ZDRAVLJE I ENERGIJA**

Noge i stopala su Ribin deo tela — i u maju su pod povećanom pažnjom. Dobre cipele, opuštanje stopala posle dugog stajanja, refleksologija, hodanje bos po prirodi — sve ovo leči Ribe na više nivoa istovremeno. Emotivno stanje je direktno vezano za fizičku gestu Riba — pazi na to da li se "vuče" ili "lebdi".

**KLJUČNI DATUMI I TRANZITI**

✦ 1. maj — Pun Mesec u Škorpiji: filozofski preokret u 9. polju — vrednosti i vera
✦ 16. maj — Mlad Mesec u Biku: komunikacijski projekti u 3. polju — pokreni!
✦ 19. maj — Venera→Rak: kreativna radost i ljubav cvatu u 5. polju
✦ 21. maj — Mars→Bik: komunikacija i lokalne prilike dobijaju zamah`,
  },
];

export const YEARLY_HOROSCOPES_2026: YearlyHoroscope[] = [
  {
    sign: 'Ovan',
    year: 2026,
    content: `**Godina Vašeg Kosmičkog Preporođaja**

2026. godina je najznačajnija godina za vas, dragi Ovnovi, u poslednjih nekoliko decenija. Ovo nije obična godina - ovo je godina kada kosmos stavlja reflektore direktno na vas i poziva vas na radikalnu transformaciju identiteta, tela i načina na koji se krećete kroz svet.

**SATURN I NEPTUN U OVNU - Vaša Najveća Lekcija**

Najvažniji astrološki događaj 2026. godine je ulazak Saturna (13. februar) i Neptuna (26. januar) u vaš znak, sa njihovom tačnom konjunkcijom 20. februara na 0°44' Ovna. Ovo se dešava jednom u 36 godina i donosi spoj strukture (Saturn) i duhovnosti (Neptun) direktno u vaš identitet.

**Šta ovo znači za vas:**
- **Identitet**: Ko ste zaista kada skinete sve maske? Saturn vas uči da budete autentični, a Neptun da budete duhovni. Neki Ovnovi će promeniti ime, izgled ili čitav životni pravac.
- **Telo**: Saturn donosi disciplinu u vezi sa telom (vežbanje, ishrana), dok Neptun donosi duhovni pristup (joga, meditacija). Ovo je godina kada možete postići fizičku transformaciju kroz duhovni rad.
- **Granice**: Saturn vas uči da postavite jasne granice, dok Neptun vas uči saosećanju. Balans između ova dva je ključ - budite čvrsti ali ljubazni.
- **Vizija**: Neptun donosi snove i vizije, Saturn ih pretvara u realnost. Ovo je godina kada možete manifestovati svoje najdublje želje kroz disciplinovan rad.

**Izazovi**: Saturn-Neptun konjunkcija može doneti konfuziju oko identiteta, osećaj izgubljenosti ili potrebu da pobegnete od odgovornosti. Ključ je da prihvatite obe energije - budite disciplinovani (Saturn) ali i otvoreni za intuiciju (Neptun).

**URAN U BLIZANCIMA - Revolucija Komunikacije**

Od 25. aprila, Uran ulazi u Blizance i aktivira vašu treću kuću komunikacije, učenja i svakodnevnih rutina. Ovo je početak 7-godišnjeg ciklusa revolucije u načinu kako komunicirate, učite i krećete se kroz svet.

**Šta očekivati:**
- **Komunikacija**: Vaš način govora i pisanja će se radikalno promeniti. Neki Ovnovi će pokrenuti blog, podcast ili YouTube kanal.
- **Učenje**: Bićete privučeni neobičnim temama - astrologija, kvantna fizika, AI, blockchain. Učićete brzo i nekonvencionalno.
- **Tehnologija**: Uran donosi tehnološke inovacije - možda ćete raditi sa AI, VR ili drugim futurističkim tehnologijama.
- **Kratka putovanja**: Iznenadna putovanja, promene u svakodnevnim rutinama, možda čak i promena načina transporta (električni automobil, bicikl).

**JUPITER U RAKU - Emocionalna Ekspanzija**

Jupiter u Raku tokom cele 2026. godine aktivira vašu četvrtu kuću doma, porodice i emocionalnih temelja. Ovo donosi rast, sreću i blagostanje u privatnom životu.

**Oblasti rasta:**
- **Dom**: Kupovina nekretnine, renoviranje, selidba u veći prostor
- **Porodica**: Produbljivanje porodičnih veza, možda dolazak novog člana porodice
- **Emocionalna sigurnost**: Osećaj da ste konačno "kod kuće" u svom životu
- **Koreni**: Istraživanje porodične istorije, povezivanje sa precima

**PLUTON U VODOLIJI - Društvena Transformacija**

Pluton u Vodoliji tokom cele godine aktivira vašu jedanaest kuću prijateljstava, zajednice i društvenih mreža. Ovo donosi duboku transformaciju vašeg društvenog života.

**Šta se menja:**
- **Prijateljstva**: Neki prijatelji će otići, novi će doći. Pluton čisti sve što nije autentično.
- **Zajednica**: Pridružićete se grupama koje dele vašu viziju i vrednosti.
- **Društvene mreže**: Transformacija vašeg online prisustva - možda ćete postati influenser ili lider u svojoj niši.
- **Vizija budućnosti**: Jasnije vidite šta želite da postignete i sa kim želite da to postignete.

**EKLIPSE - Lav/Vodolija Osa**

Dve eklipse u 2026. (17. februar i 12. avgust) aktiviraju vašu petu kuću kreativnosti i jedanaest kuću prijateljstava. Ovo donosi velike promene u vezi sa kreativnim projektima, ljubavlju, decom i društvenim životom.

**Moguće promene:**
- Početak ili kraj romantične veze
- Pokretanje kreativnog projekta koji postaje javno prepoznat
- Promene u vezi sa decom (ako ih imate)
- Transformacija društvenog kruga

**MERKUR RETROGRADAN - Tri Perioda Usporavanja**

- **Februar-Mart (Ribe)**: Usporavanje u duhovnom radu, potreba za povlačenjem
- **Jun-Jul (Rak)**: Usporavanje u porodičnim pitanjima, renoviranje doma
- **Oktobar-Novembar (Škorpija)**: Usporavanje u finansijama, potreba za dubokom transformacijom

**KLJUČNI MESECI 2026:**

**Januar-Februar**: Priprema za veliku transformaciju. Saturn i Neptun ulaze u vaš znak.

**Mart-April**: Akcija! Mars u Ovnu donosi energiju za pokretanje novih projekata.

**Maj-Jun**: Fokus na finansije i vrednosti. Vreme za zaradu.

**Jul-Avgust**: Eklipsa u Lavu donosi promene u kreativnosti i ljubavi.

**Septembar-Oktobar**: Fokus na partnerstva. Vreme za duboke relacione veze.

**Novembar-Decembar**: Transformacija i priprema za 2027.

**SAVETI ZA 2026:**

1. **Prihvatite transformaciju**: Ovo je godina kada se menjate na dubokom nivou. Ne opirati se.
2. **Budite disciplinovani**: Saturn traži strukturu. Uspostavite rutine koje vas podržavaju.
3. **Slušajte intuiciju**: Neptun donosi duhovne uvide. Meditacija je ključna.
4. **Komunicirajte autentično**: Uran u Blizancima traži iskrenost. Govorite svoju istinu.
5. **Gradite emocionalne temelje**: Jupiter u Raku traži sigurnost. Investirajte u dom i porodicu.
6. **Transformišite društveni život**: Pluton u Vodoliji traži autentične veze. Okružite se pravim ljudima.

**OBLASTI USPEHA:**
- Lični razvoj i transformacija identiteta
- Duhovni rad i meditacija
- Komunikacija i učenje novih veština
- Dom i porodica
- Društveni život i prijateljstva

**OBLASTI IZAZOVA:**
- Konfuzija oko identiteta (Saturn-Neptun)
- Potreba za postavljanjem granica
- Finansijski pritisak (potreba za disciplinom)
- Relacioni izazovi (potreba za autentičnošću)

**ZAKLJUČAK:**

2026. je vaša godina preporođaja, dragi Ovne. Kosmos vas poziva da postanete najautentičnija, najdisciplinovanija i najduhovnija verzija sebe. Ovo nije laka godina, ali je transformativna. Ono što izgradite u 2026. će biti temelj za narednih 7-12 godina vašeg života.

Prihvatite promene, slušajte intuiciju, budite disciplinovani i verujte procesu. Na kraju godine, nećete prepoznati osobu koja ste bili na početku - i to je dobro!`
  },
  {
    sign: 'Bik',
    year: 2026,
    content: `**Godina Završavanja Starih Ciklusa i Pripreme za Revoluciju**

2026. godina za vas, dragi Bikovi, je godina završavanja, oslobađanja i pripreme za najveću transformaciju vašeg života koja počinje 2027. Ovo je godina kada kosmos vas poziva da pustite prošlost, završite stare cikluse i pripremite se za radikalne promene koje dolaze.

**URAN U BIKU (do 25. aprila) - Završetak 7-Godišnjeg Ciklusa**

Od 2018. godine, Uran je bio u vašem znaku, donoseći iznenađenja, promene i revoluciju vašeg identiteta. Prvih nekoliko meseci 2026. su poslednji dani ovog tranzita - ovo je vreme za integraciju svih lekcija koje ste naučili.

**Šta ste naučili 2018-2026:**
- Ko ste zaista kada skinete sve maske
- Kako da budete autentični bez obzira šta drugi misle
- Kako da prihvatite promene umesto da im se opirati
- Kako da se oslobodite materijalnih ograničenja

**Završne lekcije (januar-april 2026):**
- Finalna transformacija identiteta, tela ili stila
- Iznenadni događaji koji vas teraju da pustite kontrolu
- Oslobađanje starih obrazaca koji vas više ne služe

**URAN ULAZI U BLIZANCE (25. april) - Finansijska Revolucija Počinje**

Od 25. aprila, Uran ulazi u Blizance i aktivira vašu drugu kuću finansija, vrednosti i materijalnih resursa. Ovo je početak 7-godišnjeg ciklusa revolucije u načinu kako zarađujete, trošite i cenite novac.

**Šta očekivati 2026-2033:**
- **Novi izvori prihoda**: Možda ćete zarađivati kroz tehnologiju, freelancing, kriptovalute ili neobične načine
- **Finansijska nestabilnost**: Uran donosi iznenađenja - neki meseci ćete imati mnogo, drugi malo. Ključ je fleksibilnost.
- **Promena vrednosti**: Šta cenite u životu? Uran vas uči da je sloboda važnija od sigurnosti.
- **Digitalna ekonomija**: Možda ćete raditi online, prodavati digitalne proizvode ili investirati u tehnologiju.

**Saveti za finansijsku revoluciju:**
- Diverzifikujte izvore prihoda - ne oslanjajte se na jedan posao
- Naučite o kriptovalutama, AI, digitalnom marketingu
- Budite otvoreni za neobične načine zarađivanja
- Štedite za nepredviđene situacije (Uran donosi iznenađenja)

**SATURN I NEPTUN U OVNU - Duhovni Rad Iza Scene**

Saturn (od 13. februara) i Neptun (od 26. januara) ulaze u Ovna i aktiviraju vašu dvanaest kuću duhovnosti, snova i onoga što je skriveno. Njihova konjunkcija 20. februara donosi spoj discipline i duhovnosti u vašem unutrašnjem svetu.

**Šta ovo znači:**
- **Duhovni rad**: Ovo je godina kada se povlačite u sebe, meditirate i radite na nesvesnim obrascima.
- **Terapija**: Neki Bikovi će raditi sa terapeutom, psihoanalitičarem ili duhovnim učiteljem.
- **Snovi**: Lucidni snovi, proročanski snovi, simboli iz nesvesnog.
- **Umetnost**: Kreativno izražavanje kroz umetnost, muziku, pisanje - sve što dolazi iz duše.
- **Oslobađanje prošlosti**: Saturn vas uči da pustite stare rane, a Neptun da oprostite.

**Izazovi**: Osećaj umora, potreba za samoćom, konfuzija oko životnog pravca. Ključ je da prihvatite ovu fazu kao pripremu za nešto veliko što dolazi.

**JUPITER U RAKU - Komunikacija i Učenje**

Jupiter u Raku tokom cele 2026. godine aktivira vašu treću kuću komunikacije, učenja i kratkih putovanja. Ovo donosi rast, sreću i prilike u ovim oblastima.

**Oblasti rasta:**
- **Učenje**: Upisaćete kurs, naučiti novu veštinu ili jezik
- **Pisanje**: Možda ćete napisati knjigu, blog ili pokrenuti podcast
- **Govorenje**: Javni nastupi, predavanja, deljenje znanja
- **Kratka putovanja**: Više putovanja po okolini, možda čak i kupovina automobila
- **Odnosi sa braćom/sestrama**: Produbljivanje veza sa rodbinom

**PLUTON U VODOLIJI - Karijerna Transformacija**

Pluton u Vodoliji tokom cele godine aktivira vašu desetu kuću karijere i javne slike. Ovo donosi duboku transformaciju vašeg profesionalnog života.

**Šta se menja:**
- **Karijera**: Neki Bikovi će potpuno promeniti karijeru, drugi će postići moć i uticaj u svojoj oblasti.
- **Javna slika**: Transformacija načina na koji vas svet vidi - možda ćete postati poznati.
- **Ambicije**: Jasnije vidite šta želite da postignete i spremni ste da se borite za to.
- **Moć**: Učite kako da koristite moć na zdrav način - ne za kontrolu, već za uticaj.

**EKLIPSE - Lav/Vodolija Osa**

Dve eklipse u 2026. (17. februar i 12. avgust) aktiviraju vašu četvrtu kuću doma i desetu kuću karijere. Ovo donosi velike promene u balansu između privatnog i profesionalnog života.

**Moguće promene:**
- Selidba zbog posla ili promena posla zbog porodice
- Kupovina nekretnine ili renoviranje
- Promene u porodičnoj strukturi
- Javno priznanje za vaš rad

**VENERA RETROGRADNA (Oktobar-Novembar)**

Venera, vaš vladar, je retrogradna u Škorpiji i Vagi tokom oktobra i novembra. Ovo aktivira vašu sedmu kuću partnerstva i šestu kuću zdravlja.

**Šta očekivati:**
- Preispitivanje odnosa - da li ste sa pravom osobom?
- Stari ljubavi se mogu vratiti
- Potreba za ravnotežom između davanja i primanja u vezi
- Fokus na zdravlje i rutinu

**KLJUČNI MESECI 2026:**

**Januar-April**: Završetak Urana u Biku. Finalna transformacija identiteta.

**Maj-Jun**: Fokus na finansije. Novi izvori prihoda.

**Jul-Avgust**: Eklipsa donosi promene u domu i karijeri.

**Septembar-Oktobar**: Fokus na zdravlje i rutinu.

**Novembar-Decembar**: Venera retrogradna - preispitivanje odnosa.

**SAVETI ZA 2026:**

1. **Pustite prošlost**: Ovo je godina završavanja. Oslobodite se svega što vas drži.
2. **Radite na sebi**: Terapija, meditacija, duhovni rad - investirajte u unutrašnji rast.
3. **Budite fleksibilni sa novcem**: Uran u Blizancima donosi finansijske promene. Diverzifikujte prihode.
4. **Učite i komunicirajte**: Jupiter u Raku donosi prilike kroz znanje. Delite što znate.
5. **Transformišite karijeru**: Pluton u Vodoliji traži autentičnost. Radite ono što volite.
6. **Balans dom-karijera**: Eklipse traže ravnotežu. Ne zanemarujte ni jedno.

**OBLASTI USPEHA:**
- Duhovni razvoj i unutrašnji rad
- Učenje i komunikacija
- Karijerna transformacija
- Finansijska diverzifikacija

**OBLASTI IZAZOVA:**
- Osećaj umora i potreba za povlačenjem
- Finansijska nestabilnost (Uran u Blizancima)
- Balans između doma i karijere
- Relacioni izazovi (Venera retrogradna)

**ZAKLJUČAK:**

2026. je vaša godina završavanja i pripreme, dragi Bikovi. Kosmos vas poziva da pustite staro, završite cikluse i pripremite se za radikalnu transformaciju koja počinje 2027. kada Uran uđe u Blizance.

Ovo nije godina velikih spoljašnjih promena - ovo je godina dubokog unutrašnjeg rada. Ono što transformišete u sebi u 2026. će se manifestovati spolja u narednih 7 godina.

Budite strpljivi, radite na sebi, i verujte procesu. Najbolje tek dolazi!`
  },
  {
    sign: 'Blizanci',
    year: 2026,
    content: `**Godina Vašeg Kosmičkog Preporođaja - Revolucija Počinje!**

2026. godina je najznačajnija godina za vas, dragi Blizanci, u poslednjih nekoliko decenija. Ovo je godina kada kosmos stavlja reflektore direktno na vas i poziva vas na radikalnu transformaciju identiteta, komunikacije i načina na koji se krećete kroz svet.

**URAN ULAZI U BLIZANCE (25. april) - Vaša 7-Godišnja Revolucija Počinje!**

Najvažniji astrološki događaj za vas u 2026. je ulazak Urana u vaš znak 25. aprila. Ovo je početak 7-godišnjeg ciklusa (2026-2033) radikalne transformacije svega što jeste.

**Šta Uran u Blizancima znači za vas:**
- **Identitet**: Ko ste zaista kada skinete sve maske? Uran vas poziva da budete najautentičnija verzija sebe, bez obzira šta drugi misle.
- **Telo**: Neki Blizanci će promeniti izgled - nova frizura, stil oblačenja, možda čak i tetovaže ili pirsing. Drugi će raditi na transformaciji tela kroz vežbanje.
- **Sloboda**: Uran donosi potrebu za slobodom. Oslobodićete se svega što vas ograničava - toksičnih odnosa, dosadnih poslova, tuđih očekivanja.
- **Iznenađenja**: Narednih 7 godina će biti puni iznenađenja u vezi sa vama lično. Život postaje nepredvidiv, ali uzbudljiv!
- **Tehnologija**: Neki Blizanci će postati poznati kroz društvene mreže, YouTube, podcast ili druge digitalne platforme.

**Izazovi**: Uran može doneti nestabilnost, anksioznost ili osećaj da ne znate ko ste. Ključ je da prihvatite promene i verujete procesu.

**SATURN I NEPTUN U OVNU - Društveni Život i Vizija Budućnosti**

Saturn (od 13. februara) i Neptun (od 26. januara) ulaze u Ovna i aktiviraju vašu jedanaest kuću prijateljstava, zajednice i društvenih mreža. Njihova konjunkcija 20. februara donosi spoj discipline i duhovnosti u vašem društvenom životu.

**Šta ovo znači:**
- **Prijateljstva**: Saturn čisti vaš društveni krug - neki prijatelji će otići, a novi, autentičniji će doći. Neptun donosi duhovne prijatelje koji dele vašu viziju.
- **Zajednica**: Pridružićete se grupama ili organizacijama koje rade na nečemu većem od vas. Možda humanitarni rad, duhovne zajednice ili kreativni kolektivi.
- **Vizija budućnosti**: Saturn vas uči da budete realni u svojim snovima, a Neptun da sanjate veliko. Balans između ova dva je ključ.
- **Društvene mreže**: Transformacija vašeg online prisustva. Neki Blizanci će postati influenseri ili lideri u svojoj niši.

**JUPITER U RAKU - Finansijska Ekspanzija**

Jupiter u Raku tokom cele 2026. godine aktivira vašu drugu kuću finansija, vrednosti i materijalnih resursa. Ovo donosi rast, sreću i prilike u finansijskoj sferi.

**Oblasti rasta:**
- **Prihodi**: Povećanje zarade, novi izvori prihoda, možda čak i pasivni prihod
- **Vrednosti**: Jasnije razumevanje šta cenite u životu - ne samo novac, već i vreme, sloboda, kreativnost
- **Samopouzdanje**: Jupiter u drugoj kući donosi osećaj vrednosti. Konačno znate koliko vredite!
- **Materijalno blagostanje**: Kupovina lepih stvari, ulaganje u sebe, uživanje u materijalnim zadovoljstvima

**PLUTON U VODOLIJI - Transformacija Učenja i Komunikacije**

Pluton u Vodoliji tokom cele godine aktivira vašu devetu kuću putovanja, visokog obrazovanja i filozofije. Ovo donosi duboku transformaciju načina kako učite, komunicirate i razumete svet.

**Šta se menja:**
- **Učenje**: Neki Blizanci će upisati fakultet, master ili doktorat. Drugi će se baviti dubokim istraživanjem tema koje ih fasciniraju.
- **Putovanja**: Transformativna putovanja koja menjaju vašu perspektivu. Možda čak i selidba u drugu zemlju.
- **Filozofija**: Promena verovanja, religije ili životne filozofije. Pluton vas uči da preispitate sve što ste mislili da znate.
- **Predavanje**: Neki Blizanci će postati učitelji, predavači ili mentori u svojoj oblasti.

**EKLIPSE - Lav/Vodolija Osa**

Dve eklipse u 2026. (17. februar i 12. avgust) aktiviraju vašu treću kuću komunikacije i devetu kuću putovanja. Ovo donosi velike promene u načinu kako komunicirate i učite.

**Moguće promene:**
- Pokretanje bloga, podcasta ili YouTube kanala
- Pisanje knjige ili članka
- Kratka ili duga putovanja koja menjaju perspektivu
- Promene u odnosima sa braćom/sestrama

**MERKUR RETROGRADAN - Tri Perioda Usporavanja**

Merkur, vaš vladar, je retrogradan tri puta u 2026:
- **Februar-Mart (Ribe)**: Usporavanje u karijeri, potreba za preispitivanjem profesionalnih ciljeva
- **Jun-Jul (Rak)**: Usporavanje u finansijama, potreba za budžetiranjem
- **Oktobar-Novembar (Škorpija)**: Usporavanje u zdravlju i rutini, potreba za odmorom

**KLJUČNI MESECI 2026:**

**Januar-April**: Priprema za veliku transformaciju. Saturn i Neptun ulaze u Ovna.

**25. April**: URAN ULAZI U BLIZANCE - vaša revolucija počinje!

**Maj-Jun**: Fokus na finansije. Jupiter donosi prilike za zaradu.

**Jul-Avgust**: Eklipsa donosi promene u komunikaciji i putovanjima.

**Septembar-Oktobar**: Fokus na dom i porodicu. Vreme za ukorenjavanje.

**Novembar-Decembar**: Kreativnost i ljubav. Vreme za igru i radost.

**SAVETI ZA 2026:**

1. **Prihvatite promene**: Uran u Blizancima donosi revoluciju. Ne opirati se - uživajte u vožnji!
2. **Budite autentični**: Vreme je da budete najiskrenije ja. Bez maski, bez pretvaranja.
3. **Čistite društveni krug**: Saturn u jedanaestoj kući traži kvalitet, ne kvantitet. Okružite se pravim ljudima.
4. **Investirajte u sebe**: Jupiter u drugoj kući donosi novac - koristite ga za lični razvoj.
5. **Učite i putujte**: Pluton u devetoj kući traži širenje horizonata. Istražujte svet!
6. **Komunicirajte autentično**: Eklipse traže iskrenost. Govorite svoju istinu.

**OBLASTI USPEHA:**
- Lični razvoj i transformacija identiteta
- Finansijski rast i materijalno blagostanje
- Društveni život i prijateljstva
- Učenje i putovanja
- Komunikacija i kreativno izražavanje

**OBLASTI IZAZOVA:**
- Nestabilnost zbog Urana (prihvatite je!)
- Čišćenje društvenog kruga (bolno ali neophodno)
- Finansijska odgovornost (Jupiter može doneti i prekomerno trošenje)
- Balans između slobode i odgovornosti

**ZAKLJUČAK:**

2026. je vaša godina revolucije, dragi Blizanci! Uran ulazi u vaš znak i donosi 7 godina radikalne transformacije. Ovo je vreme da postanete najautentičnija, najslobodnija i najuzbudljivija verzija sebe.

Prihvatite promene, budite hrabri, i verujte da kosmos ima plan za vas. Na kraju godine, nećete prepoznati osobu koja ste bili na početku - i to je najbolja stvar koja vam se mogla desiti!

Dobrodošli u vašu revoluciju! 🚀✨`
  },
  {
    sign: 'Rak',
    year: 2026,
    content: `**Godina Vašeg Najvećeg Rasta i Sreće**

2026. godina je najsrećnija godina za vas, dragi Rakovi, u poslednjih 12 godina! Jupiter, planeta sreće, ekspanzije i rasta, provodi celu godinu u vašem znaku, donoseći blagoslove, prilike i osećaj da je sve moguće.

**JUPITER U RAKU - Vaša Godina Blagoslova!**

Jupiter u vašem znaku tokom cele 2026. godine je kao kosmički poklon. Ovo se dešava jednom u 12 godina i donosi period najvećeg rasta, sreće i ekspanzije u svim oblastima života.

**Šta Jupiter u Raku znači za vas:**
- **Optimizam**: Konačno se osećate pozitivno u vezi sa životom. Teret se podiže, a vi vidite mogućnosti svuda oko sebe.
- **Rast**: Sve što započnete u 2026. ima potencijal da raste i širi se. Ovo je godina za velike poteze!
- **Sreća**: Osećaj da ste na pravom mestu u pravo vreme. Život vam se konačno slaže.
- **Prilike**: Vrata se otvaraju - u karijeri, ljubavi, finansijama. Ključ je da kažete "da" novim iskustvima.
- **Fizička ekspanzija**: Pažnja - Jupiter može doneti i povećanje težine. Balans je važan!
- **Mudrost**: Učite iz iskustava i postajete mudriji, zreliji, svesniji.

**Oblasti gde Jupiter donosi rast:**
- **Lični razvoj**: Postajete najbolja verzija sebe
- **Karijera**: Promocije, novi poslovi, javno priznanje
- **Ljubav**: Neki Rakovi će se venčati ili započeti ozbiljnu vezu
- **Porodica**: Možda dolazak novog člana porodice (beba, usvojenje)
- **Obrazovanje**: Upisivanje fakulteta, kursa ili učenje novih veština
- **Putovanja**: Više putovanja, možda čak i u daleke zemlje

**SATURN I NEPTUN U OVNU - Karijerna Transformacija**

Saturn (od 13. februara) i Neptun (od 26. januara) ulaze u Ovna i aktiviraju vašu desetu kuću karijere, javne slike i profesionalnih ambicija. Njihova konjunkcija 20. februara donosi spoj discipline i duhovnosti u vašem profesionalnom životu.

**Šta ovo znači:**
- **Karijera**: Saturn donosi ozbiljnost, odgovornost i potrebu da dokažete svoju vrednost. Neptun donosi kreativnost, intuiciju i duhovni pristup poslu.
- **Javna slika**: Transformacija načina na koji vas svet vidi. Neki Rakovi će postati poznati u svojoj oblasti.
- **Profesionalni cilj**: Saturn vas uči da budete realni, a Neptun da sanjate veliko. Balans je ključ - postavite visoke ciljeve, ali radite disciplinovano ka njima.
- **Liderstvo**: Neki Rakovi će preuzeti liderske pozicije, postati šefovi ili pokrenuti svoj biznis.
- **Kreativna karijera**: Neptun favorizuje umetničke, kreativne ili duhovne karijere - muzika, umetnost, terapija, astrologija.

**Izazovi**: Saturn može doneti pritisak, osećaj da niste dovoljno dobri ili strah od neuspeha. Neptun može doneti konfuziju oko profesionalnog pravca. Ključ je da kombinujete disciplinu (Saturn) sa intuicijom (Neptun).

**URAN ULAZI U BLIZANCE (25. april) - Finansijska Revolucija**

Od 25. aprila, Uran ulazi u Blizance i aktivira vašu dvanaest kuću duhovnosti, snova i onoga što je skriveno. Ovo je početak 7-godišnjeg ciklusa duhovne revolucije.

**Šta očekivati 2026-2033:**
- **Duhovnost**: Neki Rakovi će otkriti duhovne prakse - meditacija, joga, astrologija, energetsko lečenje
- **Nesvesno**: Rad sa snovima, terapija, istraživanje nesvesnih obrazaca
- **Povlačenje**: Potreba za samoćom, povlačenjem iz društvenog života, radom u tišini
- **Tajne**: Neke tajne mogu izaći na videlo - vaše ili tuđe
- **Umetnost**: Kreativno izražavanje kroz umetnost, muziku, pisanje - sve što dolazi iz duše

**PLUTON U VODOLIJI - Transformacija Zajedničkih Resursa**

Pluton u Vodoliji tokom cele godine aktivira vašu osmu kuću transformacije, intimnosti i zajedničkih resursa. Ovo donosi duboku transformaciju u vezi sa novcem, seksualnošću i emocionalnim vezama.

**Šta se menja:**
- **Finansije**: Transformacija odnosa prema novcu. Neki Rakovi će dobiti nasledstvo, kredit ili novac kroz partnera.
- **Intimnost**: Dublje, intenzivnije emocionalne i seksualne veze. Pluton traži autentičnost.
- **Moć**: Učite kako da koristite moć na zdrav način - ne za kontrolu, već za transformaciju.
- **Smrt i preporođaj**: Neki Rakovi će doživeti simboličnu smrt starog ja i preporođaj u novo.

**EKLIPSE - Lav/Vodolija Osa**

Dve eklipse u 2026. (17. februar i 12. avgust) aktiviraju vašu drugu kuću finansija i osmu kuću zajedničkih resursa. Ovo donosi velike promene u finansijskoj sferi.

**Moguće promene:**
- Novi izvori prihoda ili gubitak posla
- Dobijanje ili davanje novca
- Promene u zajedničkim finansijama sa partnerom
- Transformacija odnosa prema materijalnom

**MERKUR RETROGRADAN - Tri Perioda Usporavanja**

- **Februar-Mart (Ribe)**: Usporavanje u učenju i putovanjima
- **Jun-Jul (Rak)**: Usporavanje u ličnom razvoju - vreme za introspekciju
- **Oktobar-Novembar (Škorpija)**: Usporavanje u kreativnosti i ljubavi

**KLJUČNI MESECI 2026:**

**Januar-Februar**: Jupiter u Raku donosi optimizam. Saturn i Neptun ulaze u Ovna - karijerna transformacija počinje.

**Mart-April**: Fokus na karijeru. Vreme za velike profesionalne poteze.

**25. April**: Uran ulazi u Blizance - duhovna revolucija počinje.

**Maj-Jun**: Merkur retrogradan u Raku - vreme za introspekciju i lični razvoj.

**Jul-Avgust**: Eklipsa donosi finansijske promene. Budite fleksibilni.

**Septembar-Oktobar**: Fokus na kreativnost i ljubav. Vreme za radost!

**Novembar-Decembar**: Završetak godine sa osećajem zahvalnosti i rasta.

**SAVETI ZA 2026:**

1. **Kažite DA novim prilikama**: Jupiter donosi blagoslove - ne propustite ih!
2. **Radite disciplinovano na karijeri**: Saturn traži trud, ali nagrade su velike.
3. **Slušajte intuiciju**: Neptun donosi duhovne uvide - verujte sebi.
4. **Investirajte u duhovni razvoj**: Uran u dvanaestoj kući traži unutrašnji rad.
5. **Budite otvoreni za finansijske promene**: Eklipse donose transformaciju - prihvatite je.
6. **Uživajte u rastu**: Ovo je vaša godina - slavite svaki uspeh!

**OBLASTI USPEHA:**
- Lični razvoj i rast (Jupiter u Raku!)
- Karijera i javno priznanje
- Ljubav i romantika
- Porodica i dom
- Duhovni razvoj

**OBLASTI IZAZOVA:**
- Karijerni pritisak (Saturn u desetoj kući)
- Finansijske promene (eklipse)
- Potreba za balansom između rada i odmora
- Emocionalna intenzivnost (Pluton u osmoj kući)

**ZAKLJUČAK:**

2026. je vaša godina sreće, rasta i blagoslova, dragi Rakovi! Jupiter u vašem znaku donosi prilike koje se dešavaju jednom u 12 godina. Ovo je vreme da zakoračite u svoju moć, prihvatite rast i postanete najbolja verzija sebe.

Karijera će zahtevati trud, ali nagrade su ogromne. Duhovni razvoj će vas voditi ka dubljem razumevanju sebe. Finansije će se transformisati. A vi ćete na kraju godine biti mudriji, jači i srećniji nego ikad!

Ovo je vaša godina - uživajte u svakom trenutku! 🌟💙`
  },
  {
    sign: 'Lav',
    year: 2026,
    content: `**Godina Duhovnog Rasta i Pripreme za Sjaj**

2026. godina za vas, dragi Lavovi, je godina unutrašnjeg rada, duhovnog rasta i pripreme za period sjaja koji dolazi. Ovo nije godina velikih spoljašnjih uspeha - ovo je godina kada gradite čvrste temelje za budućnost.

**JUPITER U RAKU - Duhovni Rast i Unutrašnji Mir**

Jupiter u Raku tokom cele 2026. godine aktivira vašu dvanaest kuću duhovnosti, snova, povlačenja i onoga što je skriveno. Ovo donosi rast u unutrašnjem svetu, ali može biti izazovno za Lavove koji vole biti u centru pažnje.

**Šta Jupiter u dvanaestoj kući znači:**
- **Duhovnost**: Ovo je godina kada otkrivate duhovne prakse - meditacija, joga, molitva, astrologija. Neki Lavovi će doživeti duboke duhovne uvide.
- **Povlačenje**: Potreba za samoćom, tišinom, povlačenjem iz društvenog života. Ovo nije slabost - ovo je priprema za nešto veliko.
- **Snovi**: Lucidni snovi, proročanski snovi, simboli iz nesvesnog. Vodite dnevnik snova!
- **Terapija**: Neki Lavovi će raditi sa terapeutom, psihoanalitičarem ili duhovnim učiteljem na dubokim emocionalnim obrascima.
- **Umetnost**: Kreativno izražavanje kroz umetnost, muziku, pisanje - sve što dolazi iz duše, ne iz ega.
- **Humanitarni rad**: Rad iza scene, pomaganje drugima bez potrebe za priznanjem.

**Izazovi**: Jupiter u dvanaestoj kući može doneti osećaj izolacije, umora ili konfuzije oko životnog pravca. Ključ je da prihvatite ovu fazu kao pripremu - sledeće godine (2027) Jupiter ulazi u Lava i donosi period sjaja!

**SATURN I NEPTUN U OVNU - Širenje Horizonata**

Saturn (od 13. februara) i Neptun (od 26. januara) ulaze u Ovna i aktiviraju vašu devetu kuću putovanja, visokog obrazovanja i filozofije. Njihova konjunkcija 20. februara donosi spoj discipline i duhovnosti u učenju i istraživanju.

**Šta ovo znači:**
- **Obrazovanje**: Neki Lavovi će upisati fakultet, master ili doktorat. Saturn traži ozbiljno učenje, a Neptun donosi inspiraciju.
- **Putovanja**: Transformativna putovanja koja menjaju vašu perspektivu. Možda duga putovanja ili čak selidba u drugu zemlju.
- **Filozofija**: Promena verovanja, religije ili životne filozofije. Saturn vas uči da budete realni, a Neptun da sanjate veliko.
- **Predavanje**: Neki Lavovi će postati učitelji, predavači ili mentori u svojoj oblasti.
- **Pravni poslovi**: Rešavanje pravnih pitanja, ugovora ili dokumenata.

**URAN ULAZI U BLIZANCE (25. april) - Društvena Revolucija**

Od 25. aprila, Uran ulazi u Blizance i aktivira vašu jedanaest kuću prijateljstava, zajednice i društvenih mreža. Ovo je početak 7-godišnjeg ciklusa revolucije u društvenom životu.

**Šta očekivati 2026-2033:**
- **Prijateljstva**: Radikalne promene u društvenom krugu. Neki prijatelji će otići, novi, neobični će doći.
- **Zajednica**: Pridružićete se nekonvencionalnim grupama ili organizacijama.
- **Društvene mreže**: Transformacija online prisustva. Možda ćete postati poznati kroz društvene mreže.
- **Vizija budućnosti**: Jasnije vidite šta želite da postignete i sa kim želite da to postignete.
- **Sloboda**: Uran traži slobodu u prijateljstvima - vreme je da se okružite ljudima koji vas prihvataju onakvim kakvi jeste.

**PLUTON U VODOLIJI - Relaciona Transformacija**

Pluton u Vodoliji tokom cele godine aktivira vašu sedmu kuću partnerstva i odnosa. Ovo donosi duboku transformaciju u vezi sa romantičnim i poslovnim partnerstvima.

**Šta se menja:**
- **Odnosi**: Pluton čisti sve što nije autentično. Neki Lavovi će završiti toksične veze, drugi će produbiti postojeće.
- **Moć u odnosima**: Učite kako da delite moć sa partnerom, ne da kontrolišete ili budete kontrolisani.
- **Intimnost**: Dublje, intenzivnije emocionalne veze. Pluton traži autentičnost.
- **Poslovna partnerstva**: Transformacija poslovnih odnosa. Možda novi partneri ili završetak starih saradnji.

**EKLIPSE - Lav/Vodolija Osa**

Dve eklipse u 2026. (17. februar u Vodoliji i 12. avgust u Lavu) direktno aktiviraju vašu prvu kuću identiteta i sedmu kuću partnerstva. Ovo su najmoćniji astrološki događaji za vas u 2026!

**Šta eklipse donose:**
- **Eklipsa u Vodoliji (17. februar)**: Kulminacija u partnerstvu. Neki Lavovi će se venčati, drugi razvesti. Ovo je trenutak istine u odnosima.
- **Eklipsa u Lavu (12. avgust)**: Novi početak u vezi sa vašim identitetom. Ko ste zaista? Šta želite? Ovo je vreme za postavljanje novih namera u vezi sa sobom.

**Moguće promene:**
- Početak ili kraj romantične veze
- Promena izgleda, stila, identiteta
- Novi pravac u životu
- Transformacija načina na koji se predstavljate svetu

**VENERA RETROGRADNA (Oktobar-Novembar)**

Venera je retrogradna u Škorpiji i Vagi tokom oktobra i novembra, aktivirajući vašu četvrtu kuću doma i treću kuću komunikacije.

**Šta očekivati:**
- Preispitivanje odnosa sa porodicom
- Stari ljubavi se mogu vratiti
- Renoviranje doma ili promene u porodičnoj dinamici
- Potreba za iskrenom komunikacijom sa voljenima

**KLJUČNI MESECI 2026:**

**Januar-Februar**: Jupiter u dvanaestoj kući - vreme za povlačenje i duhovni rad. Eklipsa u Vodoliji donosi relacione promene.

**Mart-April**: Saturn i Neptun u devetoj kući - fokus na učenje i putovanja.

**25. April**: Uran ulazi u Blizance - društvena revolucija počinje.

**Maj-Jun**: Nastavak duhovnog rada. Vreme za terapiju i unutrašnji rast.

**Jul-Avgust**: Eklipsa u Lavu - vaš lični Novi Početak!

**Septembar-Oktobar**: Fokus na dom i porodicu.

**Novembar-Decembar**: Venera retrogradna - preispitivanje odnosa.

**SAVETI ZA 2026:**

1. **Prihvatite povlačenje**: Ovo je godina unutrašnjeg rada, ne spoljašnjeg sjaja. Priprema je ključna.
2. **Investirajte u duhovni razvoj**: Meditacija, terapija, duhovne prakse - ovo je vaša godina za to.
3. **Učite i putujte**: Saturn i Neptun u devetoj kući traže širenje horizonata.
4. **Transformišite odnose**: Pluton traži autentičnost. Budite iskreni sa partnerom.
5. **Budite otvoreni za društvene promene**: Uran donosi nove prijatelje i zajednice.
6. **Slušajte eklipse**: One vam pokazuju put - pratite znakove.

**OBLASTI USPEHA:**
- Duhovni razvoj i unutrašnji mir
- Učenje i visoko obrazovanje
- Putovanja i širenje perspektive
- Transformacija odnosa
- Društveni život i prijateljstva

**OBLASTI IZAZOVA:**
- Osećaj izolacije (Jupiter u dvanaestoj kući)
- Relacioni izazovi (Pluton u sedmoj kući)
- Potreba za balansom između povlačenja i društvenog života
- Emocionalna intenzivnost (eklipse)

**ZAKLJUČAK:**

2026. nije vaša godina sjaja, dragi Lavovi - ali je godina pripreme za sjaj koji dolazi! Jupiter u dvanaestoj kući vas poziva da zaronite duboko, radite na sebi i izgradite čvrste duhovne temelje.

Ovo je godina kada učite, putujete, transformišete odnose i pripremite se za 2027. kada Jupiter ulazi u Lava i donosi period najvećeg rasta i sreće.

Budite strpljivi, verujte procesu i znajte da kosmos priprema nešto veliko za vas. Povlačenje nije slabost - to je priprema za trijumf! 👑✨`
  },
  {
    sign: 'Devica',
    year: 2026,
    content: `**Godina Društvenog Rasta i Prijateljskih Veza**

2026. godina za vas, dragi Device, je godina kada kosmos stavlja fokus na vaš društveni život, prijateljstva i viziju budućnosti. Ovo je godina povezivanja sa istomišljenicima i rada na kolektivnim projektima.

**JUPITER U RAKU - Društveni Rast i Prijateljstva**

Jupiter u Raku tokom cele 2026. godine aktivira vašu jedanaest kuću prijateljstava, zajednice i društvenih mreža. Ovo donosi rast, sreću i prilike kroz društvene veze.

**Šta Jupiter u jedanaestoj kući znači:**
- **Prijateljstva**: Novi prijatelji ulaze u vaš život - ljudi koji dele vašu viziju i vrednosti. Neki Device će proširiti društveni krug značajno.
- **Zajednica**: Pridružićete se grupama, organizacijama ili zajednicama koje rade na nečemu većem od vas. Možda humanitarni rad, kreativni kolektivi ili profesionalne asocijacije.
- **Društvene mreže**: Rast online prisustva. Neki Device će postati poznati kroz društvene mreže, blog ili podcast.
- **Vizija budućnosti**: Jasnije vidite šta želite da postignete u životu i sa kim želite da to postignete.
- **Kolektivni projekti**: Rad na projektima sa drugima. Timski rad donosi uspeh.
- **Sreća kroz druge**: Osećaj pripadnosti, prihvaćenosti i podrške od zajednice.

**SATURN I NEPTUN U OVNU - Finansijska Transformacija**

Saturn (od 13. februara) i Neptun (od 26. januara) ulaze u Ovna i aktiviraju vašu osmu kuću transformacije, zajedničkih resursa i intimnosti. Njihova konjunkcija 20. februara donosi spoj discipline i duhovnosti u finansijskoj sferi.

**Šta ovo znači:**
- **Zajedničke finansije**: Saturn donosi ozbiljnost u vezi sa zajedničkim resursima - krediti, hipoteke, nasledstva, zajednički računi sa partnerom. Neptun donosi intuitivni pristup novcu.
- **Transformacija**: Duboka transformacija odnosa prema novcu, moći i kontroli. Učite kako da delite resurse na zdrav način.
- **Intimnost**: Saturn traži ozbiljnost u intimnim vezama, a Neptun donosi duhovnu povezanost. Balans između ova dva je ključ.
- **Dugovi**: Rešavanje dugova, kredita ili finansijskih obaveza. Saturn traži disciplinu i odgovornost.
- **Nasledstvo**: Neki Device će dobiti nasledstvo ili rešavati pitanja u vezi sa porodičnom imovinom.

**Izazovi**: Saturn u osmoj kući može doneti finansijski pritisak ili strah od gubitka. Neptun može doneti konfuziju oko novca. Ključ je da budete disciplinovani (Saturn) ali i da verujete procesu (Neptun).

**URAN ULAZI U BLIZANCE (25. april) - Karijerna Revolucija**

Od 25. aprila, Uran ulazi u Blizance i aktivira vašu desetu kuću karijere i javne slike. Ovo je početak 7-godišnjeg ciklusa revolucije u profesionalnom životu.

**Šta očekivati 2026-2033:**
- **Karijera**: Radikalne promene u profesionalnom životu. Neki Device će potpuno promeniti karijeru, drugi će raditi na neobičnim poslovima.
- **Javna slika**: Transformacija načina na koji vas svet vidi. Možda ćete postati poznati na neočekivan način.
- **Sloboda**: Uran traži slobodu u poslu - vreme je da radite ono što vas ispunjava, ne ono što se od vas očekuje.
- **Tehnologija**: Neki Device će raditi sa tehnologijom, AI, digitalnim marketingom ili drugim futurističkim oblastima.
- **Nestabilnost**: Karijera može biti nepredvidiva - neki meseci odlični, drugi izazovni. Fleksibilnost je ključna.

**PLUTON U VODOLIJI - Transformacija Zdravlja i Rutine**

Pluton u Vodoliji tokom cele godine aktivira vašu šestu kuću zdravlja, posla i svakodnevne rutine. Ovo donosi duboku transformaciju načina kako se brinete o sebi.

**Šta se menja:**
- **Zdravlje**: Transformacija pristupa zdravlju. Neki Device će otkriti holistički pristup, drugi će se suočiti sa zdravstvenim izazovima koji ih uče lekcijama.
- **Rutina**: Radikalna promena svakodnevnih navika. Pluton čisti sve što ne služi vašem najvišem dobru.
- **Posao**: Transformacija odnosa prema poslu. Neki Device će promeniti posao ili način na koji rade.
- **Služenje**: Učite kako da služite drugima na zdrav način - bez žrtvovanja sebe.

**EKLIPSE - Lav/Vodolija Osa**

Dve eklipse u 2026. (17. februar i 12. avgust) aktiviraju vašu šestu kuću zdravlja i dvanaest kuću duhovnosti. Ovo donosi velike promene u vezi sa zdravljem i duhovnim razvojem.

**Moguće promene:**
- Novi zdravstveni režim ili dijeta
- Promene na poslu
- Duhovni uvidi ili terapija
- Potreba za balansom između rada i odmora

**MERKUR RETROGRADAN - Tri Perioda Usporavanja**

Merkur, vaš vladar, je retrogradan tri puta u 2026:
- **Februar-Mart (Ribe)**: Usporavanje u partnerstvu, potreba za iskrenim razgovorima
- **Jun-Jul (Rak)**: Usporavanje u društvenom životu, preispitivanje prijateljstava
- **Oktobar-Novembar (Škorpija)**: Usporavanje u komunikaciji, potreba za dubokim razgovorima

**KLJUČNI MESECI 2026:**

**Januar-Februar**: Jupiter u jedanaestoj kući - novi prijatelji i društvene prilike. Eklipsa donosi zdravstvene promene.

**Mart-April**: Saturn i Neptun u osmoj kući - fokus na finansije i transformaciju.

**25. April**: Uran ulazi u Blizance - karijerna revolucija počinje!

**Maj-Jun**: Merkur retrogradan - preispitivanje prijateljstava.

**Jul-Avgust**: Eklipsa donosi duhovne uvide. Vreme za meditaciju.

**Septembar-Oktobar**: Fokus na kreativnost i ljubav.

**Novembar-Decembar**: Završetak godine sa zahvalnošću za rast.

**SAVETI ZA 2026:**

1. **Proširite društveni krug**: Jupiter donosi nove prijatelje - budite otvoreni!
2. **Budite disciplinovani sa novcem**: Saturn u osmoj kući traži finansijsku odgovornost.
3. **Prihvatite karijerne promene**: Uran donosi revoluciju - ne opirati se!
4. **Transformišite zdravlje**: Pluton traži holistički pristup - brinite se o sebi.
5. **Slušajte intuiciju**: Neptun donosi duhovne uvide - verujte sebi.
6. **Balans rada i odmora**: Eklipse traže ravnotežu - ne pregorite.

**OBLASTI USPEHA:**
- Društveni život i prijateljstva
- Kolektivni projekti i timski rad
- Karijerna transformacija
- Zdravlje i rutina
- Finansijska disciplina

**OBLASTI IZAZOVA:**
- Finansijski pritisak (Saturn u osmoj kući)
- Karijerna nestabilnost (Uran u desetoj kući)
- Zdravstveni izazovi (Pluton u šestoj kući)
- Potreba za balansom između rada i odmora

**ZAKLJUČAK:**

2026. je vaša godina društvenog rasta i profesionalne transformacije, dragi Device! Jupiter u jedanaestoj kući donosi nove prijatelje i prilike kroz zajednicu. Uran u desetoj kući donosi karijerne promene koje vas vode ka autentičnijem radu.

Finansije će zahtevati disciplinu, zdravlje će zahtevati pažnju, ali društveni život će biti izvor radosti i podrške. Okružite se pravim ljudima, radite na sebi i verujte da kosmos vodi vas ka vašem najvišem dobru.

Ovo je godina kada učite da tražite pomoć, sarađujete sa drugima i shvatate da niste sami. Zajednica je vaša snaga! 💚✨`
  },
  {
    sign: 'Vaga',
    year: 2026,
    content: `**Godina Karijerne Kulminacije i Javnog Priznanja**

2026. godina za vas, dragi Vage, je godina kada kosmos stavlja reflektore na vašu karijeru, javnu sliku i profesionalne ambicije. Ovo je godina kada možete postići velike stvari i biti prepoznati za svoj rad.

**JUPITER U RAKU - Karijerni Uspeh i Javno Priznanje**

Jupiter u Raku tokom cele 2026. godine aktivira vašu desetu kuću karijere, javne slike i profesionalnih ambicija. Ovo donosi rast, sreću i prilike u profesionalnom životu.

**Šta Jupiter u desetoj kući znači:**
- **Karijera**: Promocije, novi poslovi, povećanje plata. Ovo je godina kada možete napraviti veliki skok u karijeri.
- **Javno priznanje**: Ljudi vas vide, prepoznaju i cene vaš rad. Neki Vage će postati poznati u svojoj oblasti.
- **Liderstvo**: Preuzimanje liderskih pozicija, postajanje šefa ili pokretanje svog biznisa.
- **Reputacija**: Izgradnja čvrste profesionalne reputacije. Ljudi vam veruju i žele da rade sa vama.
- **Uspeh**: Osećaj da ste konačno na pravom mestu u karijeri. Trud se isplaćuje!
- **Mentorstvo**: Neki Vage će postati mentori ili učitelji u svojoj oblasti.

**Izazovi**: Jupiter u desetoj kući može doneti i prekomerni rad, pritisak ili osećaj da morate biti savršeni. Ključ je balans - uspeh je važan, ali ne na račun zdravlja i odnosa.

**SATURN I NEPTUN U OVNU - Relaciona Transformacija**

Saturn (od 13. februara) i Neptun (od 26. januara) ulaze u Ovna i aktiviraju vašu sedmu kuću partnerstva i odnosa. Njihova konjunkcija 20. februara donosi spoj discipline i duhovnosti u odnosima.

**Šta ovo znači:**
- **Partnerstvo**: Saturn donosi ozbiljnost u odnosima - neki Vage će se venčati, drugi će završiti veze koje ne funkcionišu. Neptun donosi duhovnu povezanost i romantiku.
- **Odgovornost**: Saturn vas uči da budete odgovorni u odnosima, da postavite granice i da ne žrtvujete sebe za druge.
- **Idealizacija**: Neptun može doneti idealizaciju partnera - da li vidite osobu onakvom kakva jeste ili svoju fantaziju? Budite realni.
- **Duhovne veze**: Neki Vage će sresti partnera sa kojim imaju duboku duhovnu povezanost.
- **Poslovna partnerstva**: Transformacija poslovnih odnosa. Možda novi partneri ili završetak starih saradnji.

**Izazovi**: Saturn može doneti osećaj ograničenja u vezi, a Neptun konfuziju. Ključ je da kombinujete realnost (Saturn) sa romantikom (Neptun).

**URAN ULAZI U BLIZANCE (25. april) - Revolucija Učenja**

Od 25. aprila, Uran ulazi u Blizance i aktivira vašu devetu kuću putovanja, visokog obrazovanja i filozofije. Ovo je početak 7-godišnjeg ciklusa revolucije u učenju i istraživanju.

**Šta očekivati 2026-2033:**
- **Obrazovanje**: Neki Vage će upisati neobične kurseve, studirati avangardne teme ili učiti na nekonvencionalan način.
- **Putovanja**: Iznenadna putovanja, možda čak i selidba u drugu zemlju. Uran donosi avanture!
- **Filozofija**: Promena verovanja, religije ili životne filozofije. Uran vas uči da preispitate sve što ste mislili da znate.
- **Tehnologija**: Učenje kroz tehnologiju - online kursevi, AI, VR.
- **Sloboda**: Potreba za slobodom u učenju i istraživanju. Vreme je da istražujete svet bez ograničenja.

**PLUTON U VODOLIJI - Transformacija Kreativnosti**

Pluton u Vodoliji tokom cele godine aktivira vašu petu kuću kreativnosti, ljubavi, zabave i dece. Ovo donosi duboku transformaciju u vezi sa kreativnim izražavanjem i romantikom.

**Šta se menja:**
- **Kreativnost**: Transformacija kreativnog izražavanja. Neki Vage će otkriti nove talente ili se baviti umetnošću na dubljem nivou.
- **Ljubav**: Intenzivne, strastvene romantične veze. Pluton traži autentičnost - površne veze neće opstati.
- **Deca**: Ako imate decu, transformacija odnosa sa njima. Ako ne, možda odluka o roditeljstvu.
- **Igra**: Učite kako da se igrate, uživate i budete spontani - ne sve mora biti ozbiljno!

**EKLIPSE - Lav/Vodolija Osa**

Dve eklipse u 2026. (17. februar u Vodoliji i 12. avgust u Lavu) aktiviraju vašu petu kuću kreativnosti i jedanaest kuću prijateljstava. Ovo donosi velike promene u vezi sa ljubavlju i društvenim životom.

**Moguće promene:**
- **Eklipsa u Vodoliji (17. februar)**: Kulminacija u prijateljstvima. Neki prijatelji odlaze, novi dolaze.
- **Eklipsa u Lavu (12. avgust)**: Novi početak u ljubavi ili kreativnosti. Možda nova romantična veza ili kreativni projekat.

**VENERA RETROGRADNA (Oktobar-Novembar)**

Venera, vaš vladar, je retrogradna u Škorpiji i Vagi tokom oktobra i novembra. Ovo direktno aktivira vaš znak i vašu drugu kuću finansija.

**Šta očekivati:**
- Preispitivanje odnosa - da li ste sa pravom osobom?
- Stari ljubavi se mogu vratiti
- Finansijske promene - preispitivanje budžeta
- Potreba za samopouzdanjem i vrednovanjem sebe

**KLJUČNI MESECI 2026:**

**Januar-Februar**: Jupiter u desetoj kući - karijerne prilike! Eklipsa u Vodoliji donosi društvene promene.

**Mart-April**: Saturn i Neptun u sedmoj kući - fokus na odnose.

**25. April**: Uran ulazi u Blizance - revolucija učenja počinje!

**Maj-Jun**: Nastavak karijern og rasta. Vreme za velike profesionalne poteze.

**Jul-Avgust**: Eklipsa u Lavu - novi početak u ljubavi!

**Septembar-Oktobar**: Fokus na zdravlje i rutinu.

**Oktobar-Novembar**: Venera retrogradna - preispitivanje odnosa i finansija.

**Decembar**: Završetak godine sa zahvalnošću za uspeh.

**SAVETI ZA 2026:**

1. **Fokusirajte se na karijeru**: Jupiter donosi prilike - iskoristite ih maksimalno!
2. **Budite ozbiljni u odnosima**: Saturn traži autentičnost - ne zadovoljavajte se manje.
3. **Učite i putujte**: Uran donosi avanture - budite otvoreni za novo!
4. **Transformišite kreativnost**: Pluton traži dubinu - izrazite svoju dušu.
5. **Slušajte eklipse**: One vam pokazuju put u ljubavi i prijateljstvima.
6. **Balans karijere i odnosa**: Ne žrtvujte jedno za drugo.

**OBLASTI USPEHA:**
- Karijera i javno priznanje
- Profesionalni rast i liderstvo
- Učenje i putovanja
- Kreativnost i umetničko izražavanje
- Transformacija odnosa

**OBLASTI IZAZOVA:**
- Relacioni izazovi (Saturn u sedmoj kući)
- Balans između karijere i privatnog života
- Finansijske promene (Venera retrogradna)
- Emocionalna intenzivnost (Pluton u petoj kući)

**ZAKLJUČAK:**

2026. je vaša godina karijern og uspeha i relacione transformacije, dragi Vage! Jupiter u desetoj kući donosi prilike za profesionalni rast koje se dešavaju jednom u 12 godina. Ovo je vreme da zakoračite u svoju moć i budete prepoznati za svoj rad.

Odnosi će zahtevati ozbiljnost i autentičnost. Kreativnost će vas voditi ka dubljem izražavanju. Učenje će vas voditi ka novim avanturama. A vi ćete na kraju godine biti uspešniji, mudriji i ispunjeniji nego ikad!

Ovo je vaša godina sjaja - uživajte u svakom trenutku! ⚖️✨`
  },
  {
    sign: 'Škorpija',
    year: 2026,
    content: `**Godina Širenja Horizonata i Filozofskog Rasta**

2026. godina za vas, dragi Škorpije, je godina kada kosmos vas poziva da razmišljate šire, učite dublje i istražujete dalje. Ovo je godina širenja perspektive i filozofskog rasta.

**JUPITER U RAKU - Učenje, Putovanja i Mudrost**

Jupiter u Raku tokom cele 2026. godine aktivira vašu devetu kuću putovanja, visokog obrazovanja i filozofije. Ovo donosi rast, sreću i prilike kroz učenje i istraživanje.

**Šta Jupiter u devetoj kući znači:**
- **Visoko obrazovanje**: Neki Škorpije će upisati fakultet, master ili doktorat. Ovo je godina za ozbiljno učenje.
- **Putovanja**: Više putovanja, posebno duga putovanja u daleke zemlje. Neki Škorpije će čak i živeti u inostranstvu neko vreme.
- **Filozofija**: Promena verovanja, religije ili životne filozofije. Jupiter donosi mudrost i šire razumevanje.
- **Predavanje**: Neki Škorpije će postati učitelji, predavači ili mentori u svojoj oblasti.
- **Pravni poslovi**: Rešavanje pravnih pitanja, ugovora ili dokumenata. Jupiter donosi povoljne ishode.
- **Izdavaštvo**: Pisanje knjige, članka ili blog posta. Deljenje znanja sa svetom.

**SATURN I NEPTUN U OVNU - Zdravstvena Transformacija**

Saturn (od 13. februara) i Neptun (od 26. januara) ulaze u Ovna i aktiviraju vašu šestu kuću zdravlja, posla i svakodnevne rutine. Njihova konjunkcija 20. februara donosi spoj discipline i duhovnosti u zdravlju.

**Šta ovo znači:**
- **Zdravlje**: Saturn donosi disciplinu u vezi sa zdravljem - vežbanje, dijeta, redovni pregledi. Neptun donosi holistički pristup - joga, meditacija, energetsko lečenje.
- **Rutina**: Transformacija svakodnevnih navika. Saturn traži strukturu, a Neptun intuitivni pristup.
- **Posao**: Ozbiljnost na poslu, možda više odgovornosti ili novi posao koji zahteva disciplinu.
- **Služenje**: Učite kako da služite drugima na zdrav način - bez žrtvovanja sebe.

**Izazovi**: Saturn može doneti zdravstvene izazove ili pritisak na poslu. Neptun može doneti umor ili konfuziju. Ključ je balans između discipline (Saturn) i intuicije (Neptun).

**URAN ULAZI U BLIZANCE (25. april) - Finansijska Revolucija**

Od 25. aprila, Uran ulazi u Blizance i aktivira vašu osmu kuću transformacije, zajedničkih resursa i intimnosti. Ovo je početak 7-godišnjeg ciklusa revolucije u finansijskoj sferi.

**Šta očekivati 2026-2033:**
- **Zajedničke finansije**: Radikalne promene u vezi sa zajedničkim resursima - krediti, hipoteke, nasledstva, zajednički računi.
- **Iznenađenja**: Uran donosi finansijske iznenađenja - neki meseci odlični, drugi izazovni. Fleksibilnost je ključna.
- **Transformacija**: Duboka transformacija odnosa prema novcu, moći i kontroli.
- **Intimnost**: Revolucija u intimnim vezama. Neki Škorpije će istražiti neobične seksualne prakse ili duhovne tehnike.
- **Nasledstvo**: Iznenadna nasledstva ili gubici. Uran je nepredvidiv.

**PLUTON U VODOLIJI - Transformacija Doma**

Pluton, vaš moderni vladar, je u Vodoliji tokom cele godine, aktivirajući vašu četvrtu kuću doma, porodice i emocionalnih temelja. Ovo donosi duboku transformaciju vašeg privatnog života.

**Šta se menja:**
- **Dom**: Selidba, renoviranje ili radikalna promena životnog prostora. Pluton čisti sve što ne služi vašem najvišem dobru.
- **Porodica**: Transformacija porodičnih odnosa. Neki Škorpije će se suočiti sa porodičnim tajnama ili rešavati stare rane.
- **Emocionalni temelji**: Duboki rad na emocionalnoj sigurnosti. Šta vas čini sigurnim? Gde je vaš dom?
- **Koreni**: Istraživanje porodične istorije, povezivanje sa precima.

**EKLIPSE - Lav/Vodolija Osa**

Dve eklipse u 2026. (17. februar i 12. avgust) aktiviraju vašu četvrtu kuću doma i desetu kuću karijere. Ovo donosi velike promene u balansu između privatnog i profesionalnog života.

**Moguće promene:**
- Selidba zbog posla ili promena posla zbog porodice
- Kupovina nekretnine ili renoviranje
- Promene u porodičnoj strukturi
- Karijerne prilike ili izazovi

**MARS RETROGRADAN (Decembar 2025 - Februar 2026)**

Mars, vaš tradicionalni vladar, je retrogradan u Lavu i Raku od decembra 2025 do februara 2026, aktivirajući vašu devetu i desetu kuću.

**Šta očekivati:**
- Usporavanje u učenju ili putovanjima
- Preispitivanje karijern ih ciljeva
- Potreba za strpljenjem u profesionalnom životu

**KLJUČNI MESECI 2026:**

**Januar-Februar**: Jupiter u devetoj kući - prilike za učenje i putovanja. Mars retrogradan - usporite.

**Mart-April**: Saturn i Neptun u šestoj kući - fokus na zdravlje i rutinu.

**25. April**: Uran ulazi u Blizance - finansijska revolucija počinje!

**Maj-Jun**: Nastavak učenja i putovanja. Možda duga putovanja.

**Jul-Avgust**: Eklipse donose promene u domu i karijeri.

**Septembar-Oktobar**: Fokus na kreativnost i ljubav.

**Novembar-Decembar**: Završetak godine sa zahvalnošću za rast.

**SAVETI ZA 2026:**

1. **Učite i putujte**: Jupiter donosi prilike - iskoristite ih!
2. **Brinite se o zdravlju**: Saturn traži disciplinu - uspostavite zdrave navike.
3. **Budite fleksibilni sa novcem**: Uran donosi promene - diverzifikujte prihode.
4. **Transformišite dom**: Pluton traži promene - kreirajte prostor koji vas podržava.
5. **Balans doma i karijere**: Eklipse traže ravnotežu - ne zanemarujte ni jedno.
6. **Slušajte intuiciju**: Neptun donosi duhovne uvide - verujte sebi.

**OBLASTI USPEHA:**
- Učenje i visoko obrazovanje
- Putovanja i istraživanje
- Zdravlje i rutina
- Transformacija doma
- Filozofski rast

**OBLASTI IZAZOVA:**
- Zdravstveni izazovi (Saturn u šestoj kući)
- Finansijska nestabilnost (Uran u osmoj kući)
- Balans između doma i karijere
- Emocionalna intenzivnost (Pluton u četvrtoj kući)

**ZAKLJUČAK:**

2026. je vaša godina širenja horizonata i transformacije temelja, dragi Škorpije! Jupiter u devetoj kući donosi prilike za učenje i putovanja koje se dešavaju jednom u 12 godina. Ovo je vreme da istražujete svet, učite novo i širite svoju perspektivu.

Zdravlje će zahtevati pažnju, finansije će biti nepredvidive, dom će se transformisati. Ali kroz sve to, vi ćete rasti, učiti i postajati mudriji.

Ovo je godina kada izlazite iz zone komfora i istražujete nepoznato. Budite hrabri! 🦂✨`
  },
  {
    sign: 'Strelac',
    year: 2026,
    content: `**Godina Duboke Transformacije i Finansijske Moći**

2026. godina za vas, dragi Strelci, je godina kada kosmos vas poziva da zaronite duboko, suočite se sa strahovima i transformišete ono što više ne služi. Ovo je godina moći, intimnosti i finansijske transformacije.

**JUPITER U RAKU - Finansijska Transformacija**

Jupiter u Raku tokom cele 2026. godine aktivira vašu osmu kuću transformacije, zajedničkih resursa i intimnosti. Ovo donosi rast, sreću i prilike kroz duboku transformaciju.

**Šta Jupiter u osmoj kući znači:**
- **Zajedničke finansije**: Rast kroz zajedničke resurse - možda nasledstvo, kredit sa povoljnim uslovima, ili finansijska podrška od partnera.
- **Transformacija**: Duboka emocionalna i psihološka transformacija. Jupiter čini ovaj proces lakšim i smislenijim.
- **Intimnost**: Produbljivanje intimnih veza. Neki Strelci će doživeti najdublju emocionalnu povezanost u životu.
- **Istraživanje misterija**: Privlačnost ka astrologiji, psihologiji, okultizmu, duhovnim praksama.
- **Terapija**: Neki Strelci će raditi sa terapeutom i doživeti velike uvide.
- **Seksualna ekspanzija**: Istraživanje seksualnosti na dubljem, duhovnijem nivou.

**SATURN I NEPTUN U OVNU - Kreativna Disciplina**

Saturn (od 13. februara) i Neptun (od 26. januara) ulaze u Ovna i aktiviraju vašu petu kuću kreativnosti, ljubavi, zabave i dece. Njihova konjunkcija 20. februara donosi spoj discipline i duhovnosti u kreativnom izražavanju.

**Šta ovo znači:**
- **Kreativnost**: Saturn donosi disciplinu u kreativnom radu - neki Strelci će ozbiljno raditi na umetničkim projektima. Neptun donosi inspiraciju i duhovnost.
- **Ljubav**: Saturn traži ozbiljnost u romantičnim vezama - površne veze neće opstati. Neptun donosi romantiku i duhovnu povezanost.
- **Deca**: Ako imate decu, Saturn donosi odgovornost, a Neptun saosećanje. Ako ne, možda odluka o roditeljstvu.
- **Igra**: Učite kako da balansira te ozbiljnost (Saturn) sa igrom (Neptun).

**Izazovi**: Saturn može doneti osećaj ograničenja u ljubavi ili kreativnosti. Neptun može doneti idealizaciju. Ključ je realnost sa dozom magije.

**URAN ULAZI U BLIZANCE (25. april) - Relaciona Revolucija**

Od 25. aprila, Uran ulazi u Blizance i aktivira vašu sedmu kuću partnerstva i odnosa. Ovo je početak 7-godišnjeg ciklusa revolucije u odnosima.

**Šta očekivati 2026-2033:**
- **Partnerstvo**: Radikalne promene u romantičnim i poslovnim partnerstvima. Neki Strelci će se venčati ili razvesti na neočekivan način.
- **Sloboda**: Uran traži slobodu u odnosima - vreme je da budete u vezi koja vas ne ograničava.
- **Neobični partneri**: Privlačenje nekonvencionalnih partnera - ljudi koji su drugačiji, jedinstveni, slobodni.
- **Iznenađenja**: Odnosi postaju nepredvidivi - neki se završavaju iznenada, drugi počinju neočekivano.
- **Autentičnost**: Vreme je da budete potpuno autentični u odnosima - bez maski.

**PLUTON U VODOLIJI - Transformacija Komunikacije**

Pluton u Vodoliji tokom cele godine aktivira vašu treću kuću komunikacije, učenja i svakodnevnih interakcija. Ovo donosi duboku transformaciju načina kako komunicirate.

**Šta se menja:**
- **Komunikacija**: Transformacija načina govora i pisanja. Neki Strelci će postati moćni govornici ili pisci.
- **Učenje**: Duboko, intenzivno učenje. Pluton traži suštinu, ne površinu.
- **Odnosi sa braćom/sestrama**: Transformacija ovih odnosa. Možda rešavanje starih konflikata.
- **Svakodnevne rutine**: Radikalna promena načina na koji se krećete kroz svet.

**EKLIPSE - Lav/Vodolija Osa**

Dve eklipse u 2026. (17. februar i 12. avgust) aktiviraju vašu treću kuću komunikacije i devetu kuću putovanja. Ovo donosi velike promene u učenju i istraživanju.

**Moguće promene:**
- Pokretanje bloga, podcasta ili pisanje knjige
- Kratka ili duga putovanja
- Promene u obrazovanju
- Transformacija načina komunikacije

**KLJUČNI MESECI 2026:**

**Januar-Februar**: Jupiter u osmoj kući - duboka transformacija počinje. Eklipsa donosi komunikacijske promene.

**Mart-April**: Saturn i Neptun u petoj kući - fokus na kreativnost i ljubav.

**25. April**: Uran ulazi u Blizance - relaciona revolucija počinje!

**Maj-Jun**: Nastavak transformacije. Možda terapija ili duhovni rad.

**Jul-Avgust**: Eklipsa donosi promene u putovanjima i učenju.

**Septembar-Oktobar**: Fokus na zdravlje i rutinu.

**Novembar-Decembar**: Završetak godine sa zahvalnošću za transformaciju.

**SAVETI ZA 2026:**

1. **Prihvatite transformaciju**: Jupiter u osmoj kući donosi duboke promene - ne opirati se!
2. **Budite ozbiljni u ljubavi**: Saturn traži autentičnost - ne zadovoljavajte se manje.
3. **Prihvatite relacione promene**: Uran donosi revoluciju - budite otvoreni.
4. **Transformišite komunikaciju**: Pluton traži moć u rečima - govorite svoju istinu.
5. **Radite na sebi**: Terapija, meditacija, duhovni rad - investirajte u unutrašnji rast.
6. **Balans ozbiljnosti i igre**: Saturn i Neptun traže ravnotežu.

**OBLASTI USPEHA:**
- Duboka emocionalna transformacija
- Finansijski rast kroz zajedničke resurse
- Kreativno izražavanje
- Relaciona autentičnost
- Komunikacijska moć

**OBLASTI IZAZOVA:**
- Emocionalna intenzivnost (Jupiter u osmoj kući)
- Ljubavni izazovi (Saturn u petoj kući)
- Relaciona nestabilnost (Uran u sedmoj kući)
- Potreba za dubokim radom na sebi

**ZAKLJUČAK:**

2026. je vaša godina duboke transformacije i relacione revolucije, dragi Strelci! Jupiter u osmoj kući donosi prilike za rast kroz intimnost, finansije i psihološki rad. Ovo je vreme da zaronite duboko i suočite se sa onim što ste izbegavali.

Ljubav će zahtevati ozbiljnost, odnosi će se transformisati, komunikacija će postati moćnija. A vi ćete na kraju godine biti dublji, jači i autentičniji nego ikad!

Ovo je godina kada učite da budete ranjivi, otvoreni i moćni istovremeno. Transformacija je vaš poklon! 🏹✨`
  },
  {
    sign: 'Jarac',
    year: 2026,
    content: `**Godina Relacionog Rasta i Partnerske Harmonije**

2026. godina za vas, dragi Jarci, je godina kada kosmos stavlja fokus na vaše odnose, partnerstva i način na koji se povezujete sa drugima. Ovo je godina balansa između vas i drugih.

**JUPITER U RAKU - Relacioni Rast i Partnerstvo**

Jupiter u Raku tokom cele 2026. godine aktivira vašu sedmu kuću partnerstva i odnosa. Ovo donosi rast, sreću i prilike kroz romantične i poslovne veze.

**Šta Jupiter u sedmoj kući znači:**
- **Romantika**: Neki Jarci će se venčati, veriti ili započeti ozbiljnu vezu. Ovo je godina ljubavi!
- **Poslovna partnerstva**: Novi poslovni partneri, saradnje ili ugovori. Jupiter donosi povoljne ishode.
- **Rast kroz druge**: Učite i rastete kroz odnose sa drugima. Partneri vam donose mudrost.
- **Balans**: Učite kako da balansirate svoje potrebe sa potrebama drugih.
- **Pravni poslovi**: Povoljni ishodi u pravnim pitanjima, ugovorima ili pregovorima.
- **Konsultacije**: Neki Jarci će raditi kao konsultanti ili savetnici.

**Izazovi**: Jupiter može doneti i prekomerno davanje u odnosima ili idealizaciju partnera. Ključ je balans.

**SATURN U JARCU (do 13. februara) - Završetak Ciklusa**

Prvih nekoliko nedelja 2026. Saturn je još uvek u vašem znaku, završavajući 3-godišnji ciklus koji je počeo 2023. Ovo je vreme za integraciju svih lekcija koje ste naučili.

**Finalne lekcije:**
- Ko ste zaista kada skinete sve maske?
- Koje granice treba da postavite?
- Šta je vaša odgovornost, a šta nije?

**SATURN I NEPTUN U OVNU - Transformacija Doma**

Saturn (od 13. februara) i Neptun (od 26. januara) ulaze u Ovna i aktiviraju vašu četvrtu kuću doma, porodice i emocionalnih temelja. Njihova konjunkcija 20. februara donosi spoj discipline i duhovnosti u privatnom životu.

**Šta ovo znači:**
- **Dom**: Saturn donosi ozbiljnost u vezi sa domom - možda kupovina nekretnine, renoviranje ili selidba. Neptun donosi potrebu za svetim prostorom.
- **Porodica**: Transformacija porodičnih odnosa. Saturn traži odgovornost, a Neptun saosećanje.
- **Emocionalni temelji**: Duboki rad na emocionalnoj sigurnosti. Šta vas čini sigurnim?
- **Koreni**: Istraživanje porodične istorije, povezivanje sa precima.

**URAN ULAZI U BLIZANCE (25. april) - Zdravstvena Revolucija**

Od 25. aprila, Uran ulazi u Blizance i aktivira vašu šestu kuću zdravlja, posla i svakodnevne rutine. Ovo je početak 7-godišnjeg ciklusa revolucije u zdravlju i radu.

**Šta očekivati 2026-2033:**
- **Zdravlje**: Radikalne promene u pristupu zdravlju. Neki Jarci će otkriti neobične zdravstvene prakse.
- **Posao**: Promene na poslu - možda freelancing, rad od kuće ili nekonvencionalni poslovi.
- **Rutina**: Revolucija svakodnevnih navika. Uran traži slobodu - vreme je da napravite rutinu koja vam odgovara.
- **Tehnologija**: Korišćenje tehnologije za zdravlje i produktivnost.

**PLUTON U VODOLIJI - Finansijska Transformacija**

Pluton u Vodoliji tokom cele godine aktivira vašu drugu kuću finansija, vrednosti i materijalnih resursa. Ovo donosi duboku transformaciju odnosa prema novcu.

**Šta se menja:**
- **Novac**: Transformacija načina zarađivanja. Neki Jarci će potpuno promeniti izvor prihoda.
- **Vrednosti**: Šta cenite u životu? Pluton vas uči da je sloboda važnija od sigurnosti.
- **Samopouzdanje**: Duboki rad na osećaju vrednosti. Koliko vredite?
- **Materijalno**: Oslobađanje od materijalnih ograničenja ili opsesija.

**EKLIPSE - Lav/Vodolija Osa**

Dve eklipse u 2026. (17. februar i 12. avgust) aktiviraju vašu drugu kuću finansija i osmu kuću zajedničkih resursa. Ovo donosi velike promene u finansijskoj sferi.

**Moguće promene:**
- Novi izvori prihoda ili gubitak posla
- Dobijanje ili davanje novca
- Promene u zajedničkim finansijama sa partnerom
- Transformacija odnosa prema materijalnom

**KLJUČNI MESECI 2026:**

**Januar-Februar**: Saturn završava ciklus u Jarcu. Jupiter u sedmoj kući - relacione prilike! Eklipsa donosi finansijske promene.

**Mart-April**: Saturn i Neptun u četvrtoj kući - fokus na dom i porodicu.

**25. April**: Uran ulazi u Blizance - zdravstvena revolucija počinje!

**Maj-Jun**: Nastavak relacionog rasta. Možda venčanje ili poslovno partnerstvo.

**Jul-Avgust**: Eklipsa donosi finansijske transformacije.

**Septembar-Oktobar**: Fokus na kreativnost i ljubav.

**Novembar-Decembar**: Završetak godine sa zahvalnošću za rast.

**SAVETI ZA 2026:**

1. **Otvorite se za odnose**: Jupiter donosi ljubav - ne zatvarajte se!
2. **Investirajte u dom**: Saturn traži čvrste temelje - kreirajte prostor koji vas podržava.
3. **Prihvatite zdravstvene promene**: Uran donosi revoluciju - budite otvoreni za novo.
4. **Transformišite finansije**: Pluton traži promene - diverzifikujte prihode.
5. **Balans rada i odmora**: Ne pregorite - brinite se o sebi.
6. **Slušajte partnera**: Jupiter u sedmoj kući traži saradnju - ne radite sve sami.

**OBLASTI USPEHA:**
- Romantični i poslovni odnosi
- Dom i porodica
- Finansijska transformacija
- Zdravlje i rutina
- Balans između davanja i primanja

**OBLASTI IZAZOVA:**
- Potreba za otvaranjem (teško za Jarce!)
- Finansijske promene (Pluton u drugoj kući)
- Zdravstvena nestabilnost (Uran u šestoj kući)
- Balans između karijere i doma

**ZAKLJUČAK:**

2026. je vaša godina relacionog rasta i transformacije temelja, dragi Jarci! Jupiter u sedmoj kući donosi prilike za ljubav i partnerstva koje se dešavaju jednom u 12 godina. Ovo je vreme da se otvorite, povežete i naučite da primate od drugih.

Dom će zahtevati pažnju, zdravlje će se transformisati, finansije će se menjati. Ali kroz sve to, vi ćete učiti najvažniju lekciju - da niste sami i da je u redu tražiti pomoć.

Ovo je godina kada učite da balansira te snagu sa ranjivošću. Otvorite srce! 🐐✨`
  },
  {
    sign: 'Vodolija',
    year: 2026,
    content: `**Godina Zdravlja, Rutine i Svakodnevne Magije**

2026. godina za vas, dragi Vodolije, je godina kada kosmos vas poziva da obratite pažnju na svoje telo, zdravlje i svakodnevne navike. Ovo je godina kada male promene donose velike rezultate.

**JUPITER U RAKU - Zdravstveni Rast i Rutina**

Jupiter u Raku tokom cele 2026. godine aktivira vašu šestu kuću zdravlja, posla i svakodnevne rutine. Ovo donosi rast, sreću i prilike kroz bri gu o sebi.

**Šta Jupiter u šestoj kući znači:**
- **Zdravlje**: Poboljšanje zdravlja, otkrivanje novih zdravstvenih praksi, osećaj vitalnosti. Neki Vodolije će transformisati svoje telo.
- **Posao**: Novi posao, promocija ili poboljšanje uslova na poslu. Jupiter donosi prilike kroz svakodnevni rad.
- **Rutina**: Uspostavljanje zdravih navika koje vam donose radost. Ovo nije disciplina - ovo je ljubav prema sebi.
- **Služenje**: Neki Vodolije će raditi u oblastima koje pomažu drugima - zdravstvo, terapija, socijalni rad.
- **Kućni ljubimci**: Možda novi kućni ljubimac koji donosi radost.
- **Produktivnost**: Osećaj da ste produktivni, korisni, da vaš rad ima smisla.

**SATURN I NEPTUN U OVNU - Komunikacijska Transformacija**

Saturn (od 13. februara) i Neptun (od 26. januara) ulaze u Ovna i aktiviraju vašu treću kuću komunikacije, učenja i svakodnevnih interakcija. Njihova konjunkcija 20. februara donosi spoj discipline i duhovnosti u komunikaciji.

**Šta ovo znači:**
- **Komunikacija**: Saturn donosi ozbiljnost u govoru i pisanju - neki Vodolije će pisati knjigu ili pokrenuti blog. Neptun donosi inspiraciju i kreativnost.
- **Učenje**: Disciplinovano učenje novih veština. Saturn traži strukturu, a Neptun intuiciju.
- **Odnosi sa braćom/sestrama**: Transformacija ovih odnosa. Možda rešavanje starih konflikata.
- **Kratka putovanja**: Više kratkih putovanja, ali sa dubokim smislom.

**URAN ULAZI U BLIZANCE (25. april) - Kreativna Revolucija**

Od 25. aprila, Uran ulazi u Blizance i aktivira vašu petu kuću kreativnosti, ljubavi, zabave i dece. Ovo je početak 7-godišnjeg ciklusa revolucije u kreativnom izražavanju.

**Šta očekivati 2026-2033:**
- **Kreativnost**: Radikalne promene u kreativnom izražavanju. Neki Vodolije će otkriti nove talente ili se baviti avangardnom umetnošću.
- **Ljubav**: Neobične, nekonvencionalne romantične veze. Uran donosi partnere koji su drugačiji, jedinstveni.
- **Deca**: Ako imate decu, oni će vas iznenaditi. Ako ne, možda neočekivana odluka o roditeljstvu.
- **Igra**: Učite kako da se igrate, uživate i budete spontani na neočekivane načine.
- **Rizik**: Uran traži da izađete iz zone komfora i rizikujete u kreativnosti i ljubavi.

**PLUTON U VODOLIJI - Lična Transformacija**

Pluton u vašem znaku tokom cele godine donosi najdublju transformaciju vašeg identiteta, tela i načina na koji se predstavljate svetu. Ovo se dešava jednom u 248 godina!

**Šta se menja:**
- **Identitet**: Ko ste zaista? Pluton čisti sve što nije autentično. Neki Vodolije će promeniti ime, izgled ili čitav životni pravac.
- **Moć**: Učite kako da koristite svoju moć na zdrav način - ne za kontrolu, već za transformaciju.
- **Telo**: Duboka transformacija odnosa prema telu. Neki Vodolije će raditi na fizičkoj transformaciji.
- **Preporođaj**: Simbolična smrt starog ja i preporođaj u novo, autentičnije ja.

**EKLIPSE - Lav/Vodolija Osa**

Dve eklipse u 2026. (17. februar u Vodoliji i 12. avgust u Lavu) direktno aktiviraju vašu prvu kuću identiteta i sedmu kuću partnerstva. Ovo su najmoćniji astrološki događaji za vas!

**Šta eklipse donose:**
- **Eklipsa u Vodoliji (17. februar)**: Novi početak u vezi sa vašim identitetom. Ko želite da budete? Ovo je vreme za postavljanje novih namera.
- **Eklipsa u Lavu (12. avgust)**: Kulminacija u partnerstvu. Neki Vodolije će se venčati, drugi završiti vezu.

**Moguće promene:**
- Promena izgleda, stila, identiteta
- Početak ili kraj romantične veze
- Novi pravac u životu
- Transformacija načina na koji se predstavljate svetu

**KLJUČNI MESECI 2026:**

**Januar-Februar**: Jupiter u šestoj kući - fokus na zdravlje. Eklipsa u Vodoliji - vaš lični Novi Početak!

**Mart-April**: Saturn i Neptun u trećoj kući - fokus na komunikaciju i učenje.

**25. April**: Uran ulazi u Blizance - kreativna revolucija počinje!

**Maj-Jun**: Nastavak zdravstvenog rasta. Vreme za nove navike.

**Jul-Avgust**: Eklipsa u Lavu - relacione promene.

**Septembar-Oktobar**: Fokus na dom i porodicu.

**Novembar-Decembar**: Završetak godine sa zahvalnošću za transformaciju.

**SAVETI ZA 2026:**

1. **Brinite se o zdravlju**: Jupiter donosi prilike - uspostavite zdrave navike!
2. **Komunicirajte autentično**: Saturn traži iskrenost - govorite svoju istinu.
3. **Prihvatite kreativnu revoluciju**: Uran donosi promene - budite otvoreni!
4. **Transformišite identitet**: Pluton traži autentičnost - budite ko jeste.
5. **Slušajte eklipse**: One vam pokazuju put - pratite znakove.
6. **Balans sebe i drugih**: Ne zanemarujte odnose zbog fokusa na sebe.

**OBLASTI USPEHA:**
- Zdravlje i vitalnost
- Posao i produktivnost
- Komunikacija i učenje
- Kreativno izražavanje
- Lična transformacija

**OBLASTI IZAZOVA:**
- Relacioni izazovi (eklipse)
- Potreba za balansom između sebe i drugih
- Intenzivnost transformacije (Pluton u Vodoliji)
- Kreativni rizici (Uran u petoj kući)

**ZAKLJUČAK:**

2026. je vaša godina zdravlja, komunikacije i duboke lične transformacije, dragi Vodolije! Jupiter u šestoj kući donosi prilike da transformišete svoje telo i rutinu. Pluton u vašem znaku donosi najdublju transformaciju identiteta.

Ovo je godina kada postajete najautentičnija, najzdravija i najkreativnija verzija sebe. Brinite se o telu, komunicirajte iskreno, igrajte se i transformišite.

Ovo je vaša godina preporođaja - zagrlite je! ♒✨`
  },
  {
    sign: 'Ribe',
    year: 2026,
    content: `**Godina Kreativnosti, Ljubavi i Radosnog Izražavanja**

2026. godina za vas, dragi Ribe, je godina kada kosmos vas poziva da se igrate, stvarate i izražavate svoju autentičnost. Ovo je godina radosti, ljubavi i kreativnog sjaja.

**JUPITER U RAKU - Kreativni Rast i Ljubav**

Jupiter u Raku tokom cele 2026. godine aktivira vašu petu kuću kreativnosti, ljubavi, zabave i dece. Ovo donosi rast, sreću i prilike kroz kreativno izražavanje i romantiku.

**Šta Jupiter u petoj kući znači:**
- **Kreativnost**: Eksplozija kreativne energije! Neki Ribe će pokrenuti umetničke projekte, pisati, slikati, muzicirati. Ovo je vaša godina za kreativno izražavanje.
- **Ljubav**: Romantika, strast, radost! Neki Ribe će započeti novu vezu ili produbiti postojeću. Ovo je godina ljubavi!
- **Deca**: Ako imate decu, radost kroz njih. Ako ne, možda odluka o roditeljstvu ili rad sa decom.
- **Igra**: Učite kako da se igrate, uživate i budete spontani. Život nije samo ozbiljan - vreme je za zabavu!
- **Rizik**: Jupiter vas ohrabruje da rizikujete u kreativnosti i ljubavi. Izađite iz zone komfora!
- **Radost**: Osećaj da ste živi, da uživate, da život ima smisla.

**SATURN I NEPTUN U OVNU - Finansijska Transformacija**

Saturn (od 13. februara) i Neptun (od 26. januara) ulaze u Ovna i aktiviraju vašu drugu kuću finansija, vrednosti i materijalnih resursa. Njihova konjunkcija 20. februara donosi spoj discipline i duhovnosti u finansijskoj sferi.

**Šta ovo znači:**
- **Finansije**: Saturn donosi disciplinu u vezi sa novcem - budžetiranje, štednja, finansijsko planiranje. Neptun donosi intuitivni pristup i zarađivanje kroz kreativni ili duhovni rad.
- **Vrednosti**: Transformacija onoga što cenite. Šta je zaista važno? Novac ili sloboda? Materijalno ili duhovno?
- **Samopouzdanje**: Saturn vas uči da cenite sebe, a Neptun da verujete u svoju vrednost.
- **Kreativna zarada**: Neki Ribe će zarađivati kroz umetnost, muziku, terapiju, astrologija ili druge kreativne/duhovne oblasti.

**Izazovi**: Saturn može doneti finansijski pritisak ili osećaj nedostatka. Neptun može doneti konfuziju oko novca. Ključ je balans između realnosti (Saturn) i vere (Neptun).

**URAN ULAZI U BLIZANCE (25. april) - Revolucija Doma**

Od 25. aprila, Uran ulazi u Blizance i aktivira vašu četvrtu kuću doma, porodice i emocionalnih temelja. Ovo je početak 7-godišnjeg ciklusa revolucije u privatnom životu.

**Šta očekivati 2026-2033:**
- **Dom**: Radikalne promene u vezi sa domom - selidbe, renoviranja, možda čak i život na neobičnim mestima (brod, kamper, inostranstvo).
- **Porodica**: Transformacija porodičnih odnosa. Uran donosi iznenađenja - neki članovi porodice mogu iznenaditi.
- **Emocionalni temelji**: Revolucija onoga što vas čini sigurnim. Možda otkrivate da vam dom nije mesto, već osećaj.
- **Koreni**: Preispitivanje porodične istorije, možda otkrivanje porodičnih tajni.

**PLUTON U VODOLIJI - Transformacija Duhovnosti**

Pluton u Vodoliji tokom cele godine aktivira vašu dvanaest kuću duhovnosti, snova i onoga što je skriveno. Ovo donosi duboku transformaciju vašeg unutrašnjeg sveta.

**Šta se menja:**
- **Duhovnost**: Duboka transformacija duhovnih praksi. Neki Ribe će otkriti moćne duhovne tehnike ili raditi sa duhovnim učiteljem.
- **Nesvesno**: Rad sa snovima, terapija, istraživanje nesvesnih obrazaca. Pluton donosi duboke uvide.
- **Oslobađanje**: Pustite stare rane, strahove, obrasce. Pluton čisti sve što vas drži u prošlosti.
- **Umetnost**: Kreativno izražavanje iz najdubljih delova duše. Ovo je moćna energija za umetnike.

**EKLIPSE - Lav/Vodolija Osa**

Dve eklipse u 2026. (17. februar i 12. avgust) aktiviraju vašu šestu kuću zdravlja i dvanaest kuću duhovnosti. Ovo donosi velike promene u balansu između tela i duše.

**Moguće promene:**
- Novi zdravstveni režim ili dijeta
- Duhovni uvidi ili terapija
- Promene na poslu
- Potreba za balansom između materijalnog i duhovnog

**NEPTUN U OVNU (od 26. januara) - Vaš Vladar Menja Znak!**

Neptun, vaš moderni vladar, ulazi u Ovna i ostaće tu do 2039. Ovo je OGROMNA promena za vas! Neptun u Ovnu aktivira vašu drugu kuću finansija.

**Šta ovo znači:**
- Narednih 13 godina će biti fokusirani na zarađivanje kroz kreativni ili duhovni rad
- Učite kako da materijalizujete svoje snove
- Balans između duhovnog i materijalnog

**KLJUČNI MESECI 2026:**

**Januar-Februar**: Jupiter u petoj kući - kreativnost i ljubav! Neptun ulazi u Ovna - finansijska transformacija počinje.

**Mart-April**: Saturn i Neptun u drugoj kući - fokus na finansije i vrednosti.

**25. April**: Uran ulazi u Blizance - revolucija doma počinje!

**Maj-Jun**: Nastavak kreativnog rasta. Možda nova romantična veza.

**Jul-Avgust**: Eklipse donose promene u zdravlju i duhovnosti.

**Septembar-Oktobar**: Fokus na partnerstva i odnose.

**Novembar-Decembar**: Završetak godine sa zahvalnošću za radost.

**SAVETI ZA 2026:**

1. **Izrazite kreativnost**: Jupiter donosi prilike - ne zadržavajte se!
2. **Budite disciplinovani sa novcem**: Saturn traži odgovornost - napravite budžet.
3. **Prihvatite promene u domu**: Uran donosi revoluciju - budite fleksibilni.
4. **Transformišite duhovnost**: Pluton traži dubinu - radite na sebi.
5. **Uživajte u ljubavi**: Ovo je vaša godina za romantiku - otvorite srce!
6. **Balans tela i duše**: Eklipse traže ravnotežu - brinite se o oba.

**OBLASTI USPEHA:**
- Kreativnost i umetničko izražavanje
- Ljubav i romantika
- Duhovni razvoj
- Transformacija doma
- Radost i igra

**OBLASTI IZAZOVA:**
- Finansijski pritisak (Saturn u drugoj kući)
- Promene u domu (Uran u četvrtoj kući)
- Potreba za balansom između materijalnog i duhovnog
- Emocionalna intenzivnost (Pluton u dvanaestoj kući)

**ZAKLJUČAK:**

2026. je vaša godina kreativnosti, ljubavi i radosti, dragi Ribe! Jupiter u petoj kući donosi prilike za kreativno izražavanje i romantiku koje se dešavaju jednom u 12 godina. Ovo je vreme da se igrate, stvarate i volite!

Finansije će zahtevati disciplinu, dom će se transformisati, duhovnost će se produbiti. Ali kroz sve to, vi ćete učiti najvažniju lekciju - da je život za uživanje, ne samo za preživljavanje.

Ovo je godina kada učite da balansirate ozbiljnost sa igrom, materijalno sa duhovnim, realnost sa snovima. Uživajte u svakom trenutku! 🐟✨`
  }
];